import React, { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import CloseIcon from '@mui/icons-material/Close'
// import Masonry from '@mui/lab/Masonry' 
import styled from 'styled-components'
import { useFormPageHandler, useMergeState } from 'irmlib/hooks'
import { YDivider, makeStyles, useTheme } from 'irmlib/styles'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage.jsx'
import RequestTemplateFormat from '../Template/RequestListTemplate.jsx'
import { TextField, Select } from '../../../irmlib/src/components/FormControls/index.js'
import { ContainedButton } from 'irmlib/components/Controls/Button'
import { setBusy, clearBusy, openGeneralDialog, closeGeneralDialog } from 'irmlib/containers'
import { OutlinedButton, ThemeButton, MenuButton } from 'irmlib/components/Controls'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { generalDialogSelector } from '../../../irmlib/src/containers/GeneralDialog'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions.js'
import * as localGdeTransactionLite from '../../../services/firestore/localGdeTransactionsLite.js'
import * as routePaths from '../../../navigation/routePaths.js'
import * as constants from '../../../irmlib/src/common/constants.js'
import { getUser, getUserName } from '../../../redux/global.js'
import { Box, Typography, TableBody, Grid, Dialog, Button, CircularProgress } from '@material-ui/core'
import { errorToast, successToast } from '../../../common/functions.js'
import { useTranslation } from 'react-i18next'
import { LockableFields } from './LocalLockableFields.jsx'
// import IRMlogo from '../../../icons/IRM-logo.png'
import stackedLR from '../../../icons/stackedLR.png'
import stackedTB from '../../../icons/stackedTB.png'
import { Card, CardContent, Container, Table, TableCell, TableRow, TableContainer, TableHead, Checkbox } from '@mui/material'
import { getDownloadURL, ref as storageRef, uploadBytes } from 'firebase/storage'
import { storage } from '../../../utils/firestore.js'
import * as appConstants from '../../../services/common/appConstants.js'
import Camera from 'react-html5-camera-photo'
import 'react-html5-camera-photo/build/css/index.css'
import { LocalActivitySubmitImagesModal } from './LocalActivitySubmitImagesModal.jsx'
import { LocalActivityExceptionModal } from './LocalActivityExceptionModal.jsx'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'
import { MoreVert } from 'irmlib/icons'
import ImageTemplateFormat from '../Template/ImageListTemplate.jsx'
import RetakeImageTemplateFormat from '../Template/RetakeImageListTemplate.jsx'
// import { Dialog, Button } from '@material-ui/core'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Draggable from 'react-draggable'
import { doesFileSizeExceed, InputFileUploadButton } from './UploadButton.jsx'
// import { InputFileUpload } from './UploadFileButton.jsx'
import './Camera.css'
import { GroupedMenu } from './GroupedMenu.jsx'
import { TemplateAndRefOnImgCature } from './LocalMenuActivities.jsx'
import { clearFormStatus } from '../../../irmlib/src/redux/index.js'
// import { getMultiTab } from '../../../redux/global'
import RestrictImage from '../localRestrictImage.jsx'
import Resizer from 'react-image-file-resizer'
// import { uploadRefImg, getImgFromNats, getNatsURL, publishImgData } from '../../../services/nats/localNatsTransactions'
import { useNats } from '../../../providers/NatsProvider.jsx'
import { useGetNatsImage } from '../../../services/nats/useGetNatsImage'
import { updateTemplateFields } from './LocalMenuActivities.jsx'
import { Visibility } from '@material-ui/icons'
/*eslint-disable*/
const BOX_ID = 0
const SELECT_ASSET_TYPE = 1
const SELECT_ASSET_SECQUENCE = 2
const SELECT_CHANGE = 3

const initialSate = {
  activityData: {},
  activityId: '',
  selectAssetType: [],
  templateData: [],
  templateName: '',
  imagePaths: [],
  imageNUID: [],
  initialRefImgNats: {},
  requestIds: [],
  customFields: [],
  templateFields: [],
  selectedImageGsPath: false,
  templateFieldsLocked: [],
  newTemplateId: false,
  requests: {},
  showMultipleRequestsForm: false,
  showRequestInfo: false,
  accountLevel1: '',
  accountLevel2: '',
  accountLevel3: '',
  requestDocs: {},
  disableCheckbox: false,
  selectedRequest: '',
  selectedReqFields: [],
  newTemplateSelected: false,
  docId: '',
  unlockedTemplateFields: [],
  lockedTemplateFields: [],
  showModal: false,
  showExceptionModal: false,
  showExceptionModalFor: false,
  imageExceptionNote: false,
  boxExceptionNote: false,
  rejectedReqsDocs: {},
  isRejectedImage: false,
  isRetakeImage: false,
  rejectedImages: [],
  retakeImages: [],
  selectedRejectImageDocs: {},
  selectedRetakeImageDocs: {},
  selectedRejectImage: {},
  selectedRetakeImage: {},
  isSingleRequest: false,
  isRejectedImageModal: false,
  isRetakeImageModal: false,
  selectedTemplate: false,
}
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
})
const ErrorLabel = styled.label`
  display: flex;
  width: 100%;
  max-width: 300px;
  justify-content: flex-start;
  color: red;
  margin-top: 5px;
  font-size: 11px;
`
const CreateTemplateIntentContainer = styled.div`
  margin-bottom: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  width: 100%;
  max-width: 100%;
  gap: 0.5rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
  
  @media (min-width: 769px) and (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
`
const LockableFieldsWrapper = styled.div`
  width: 100%;
  overflow: visible;
  max-width: 100%;
  
  & .MuiFormControl-root {
    min-width: 100px !important;
    width: 100%;
    max-width: 100%;
    overflow: visible;
  }
  
  & .MuiTypography-root {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 100%;
    overflow: visible;
    position: relative;
    flex-wrap: nowrap;
  }
  
  & .MuiIconButton-root {
    margin: -5px -20px -5px -5px !important;
    float: right !important;
    flex-shrink: 0;
    display: inline-flex !important;
    visibility: visible !important;
    opacity: 1 !important;
    position: relative;
    z-index: 1;
  }
  
  & span {
    overflow: visible;
    white-space: nowrap;
    flex-shrink: 1;
    min-width: 0;
  }
`


const VerticalDivider = () => <YDivider height="30px" />
const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(0.5),
    borderRadius: 8,
    width: '100%',
    maxWidth: '100%',
    margin: '0.25rem',
    border: '1px solid #c9c9c9',
    fontSize: '0.875rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    overflow: 'visible',
    minWidth: 0,
    boxSizing: 'border-box'
  },
  content: {
    fontSize: '0.875rem',
    lineHeight: 2.5
  },
  value: {
    color: '#58595b'
  },

  floatingLargeImage: {
    padding: '0px 5px 10px 0px',
    height: 'auto',
    maxHeight: '92%',
    width: '100%',
    objectFit: 'contain',
  },
  floatingimagecontainer: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'hidden',
    zIndex: '10',
    maxWidth: '90vw',
    maxHeight: '90vh',
  },
}))

const RequestImageCapture = () => {
  const [showBanner, setShowBanner] = useState(false)
  const refLocalBusyCursor = useRef(null)
  const theme = useTheme()
  const [state, setState, getState] = useMergeState(initialSate)
  const [newAssetType, setNewAssetType] = useState(null)
  const [isValidBoxId, setIsValidBoxId] = useState(false)
  const [isImg, setIsImg] = useState(false)
  const [sequences, setSequences] = useState('')
  const [isSequence, setIsSequence] = useState(true)
  const [imageCount, setImageCount] = useState(0)
  const prevCropDone = useRef(true)
  const [visibleImage, setVisibleImage] = useState(null)
  const generalDialog = useSelector(generalDialogSelector)
  const [isSelectChangeMenuOpen, setIsSelectChangeMenuOpen] = useState(false)
  const [isSelectChangeActionPending, setIsSelectChangeActionPending] = useState(false)
  const [imgDocCount, setImgDocCount] = useState(0)
  const [selectedSkpBoxnum, setSelectedSkpBoxnum] = useState(null)
  const [closeBoxDisable, setCloseBoxDisable] = useState(true)
  const tableRef = useRef()
  const { t } = useTranslation()
  const [dropFirstLetterSkpBox, setDropFirstLetterSkpBox] = useState(false)
  const camera = useRef(null)
  const [cameraRef, setCameraRef] = useState(0)
  const [cameraError, setCameraError] = useState(null)
  const [totalImageCount, setTotalImageCount] = useState(0)
  const { workerId } = getUser()
  const username = getUserName()
  const [dialogOpen, setDialogOpen] = useState(false)
  const [selectAssetSequence, setSelectAssetSequence] = useState([])
  const [selectAssetSequenceUrl, setSelectAssetSequenceUrl] = useState()
  const [previewImage, setPreviewImage] = useState(false)
  const [selectedRefImage, setSelectedRefImage] = useState(null)
  const [selectedNatsRefImage, setSelectedNatsRefImage] = useState(null)
  const [loadedRefImageUrl, setLoadedRefImageUrl] = useState(null)
  const [isLoadingRefImage, setIsLoadingRefImage] = useState(false)
  const imageRef = useRef(null)
  const [imageSrc2, setImageSrc2] = useState(null)
  const [cropper, setCropper] = useState()
  const [imgUrl, setImgUrl] = useState([])
  const cropperRef = useRef(null)
  const location = useLocation()
  const pathParams = location.pathname.split('/')
  const [saveImgTrnsSuccess, SetSaveImgTrnsSuccess] = useState(null)
  const [sortMsg, setSortMsg] = useState('')
  const [selectLvls, setSelectLvls] = useState({ accountLevel1: '', accountLevel2: '', accountLevel3: '' })
  const [workflow, setWorkflow] = useState([])
  const [selectedWorkflow, setSelectedWorkflow] = useState(null)
  const { natsService } = useNats()
  const { getImgFromNats } = useGetNatsImage()
  // const isSandbox = process.env.REACT_APP_ENV === 'sandbox'
  const isSandbox = true
  const [confidence, setConfidence] = useState(0)
  const [reqData, setReqData] = useState({ dataLocation: '', activityName: '', activityType: '' })
  const fileInputRef = useRef(null)
  const uploadImageInputRef = useRef(null)
  const isSavingImagesRef = useRef(false)
  // const imageCache = useRef(new Map())
  const isDialogOpenRef = useRef(false)
  const [imageError, setImageError] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)
  const [loadingImage, setLoadingImage] = useState(false)
  const changelist = [
    {
      value: 'refImageChange', label: t('buttons.ChangeReferanceImage')
    },
    {
      value: 'templateChange', label: t('buttons.changeTemplate')
    },
    {
      value: 'templateAndrefImgChange', label: t('Search.ChangeTemplateAndRefImage')
    },
  ]

  useEffect(() => {
    arrRefs[BOX_ID]?.current?.focus()
  }, [])

  useEffect(() => {
    const channel = new BroadcastChannel('tab-duplicate-checker')
    const currentPath = location.pathname

    const handleMessage = (event) => {
      const { type, path } = event.data

      if (type === 'check' && path === currentPath) {
        channel.postMessage({ type: 'duplicate', path: currentPath })
      }

      if (type === 'duplicate' && path === currentPath) {
        setShowBanner(true)
      }
    }

    channel.onmessage = handleMessage

    channel.postMessage({ type: 'check', path: currentPath })

    return () => {
      channel.close()
    }
  }, [location])

  const classes = useStyles()

  const formTemplate = [
    {
      label: 'smartCatalog.scanBoxBarcode',
      fieldKey: 'scanBoxBarcode',
      isRequired: true,
      isRequiredError: 'forms.required',
    },
    {
      label: 'templates.assetType',
      fieldKey: 'assetType',
      isRequired: true,
      isRequiredError: 'forms.required',
    },
    {
      label: 'templates.assetSequence',
      fieldKey: 'assetSequence',
      isRequired: true,
      isRequiredError: 'forms.required',
    },
    {
      label: 'dropdowns.changeToChange',
      fieldKey: 'changeToChange',
      // isRequired: true,
      // isRequiredError: 'forms.required',
    },
  ]

  const getService = async (setState) => {
    const getObject = {
    }
    return Promise.resolve(getObject)
  }

  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })

  useEffect(async () => {
    if (getState()?.selectedRequest) {
      const requestData = await localGdeTransactionLite.getRequestById(getState()?.selectedRequest)
      setConfidence(requestData?.confidence? requestData?.confidence : 0)
      if (!selectedWorkflow) {
       setSelectedWorkflow(requestData?.dataLocation)
      }
      setReqData({ ...reqData, dataLocation: selectedWorkflow || requestData?.dataLocation || '', activityType: requestData?.activityType || '', activityName: requestData?.activityName || '' })
    }
    
    let [a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, newWorkflow] = await localGdeTransactions.getGdeConfig()
    setWorkflow(newWorkflow)
  }, [getState()?.selectedRequest, saveImgTrnsSuccess, selectedWorkflow])

  useEffect(async () => {
    let [a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, newWorkflow] = await localGdeTransactions.getGdeConfig()
    setWorkflow(newWorkflow)
    setReqData({ ...reqData, dataLocation: selectedWorkflow })
  }, [arrRefs[BOX_ID]?.current?.getValue()])

  const convertToUpperCase = async (e) => {
    let skpBoxValue = e.target.value
    const firstElement = Array.from(skpBoxValue)[0]
    const arrayOfIgnoredChars = appConstants.ignoreBarcodeScanCharacters

    if (skpBoxValue.length === 0 && dropFirstLetterSkpBox) {
      setDropFirstLetterSkpBox(false)
    }

    // if (skpBoxValue.length === 12 && arrayOfIgnoredChars.indexOf(firstElement.toUpperCase()) !== -1) {
    //   skpBoxValue = skpBoxValue.substring(1)
    //   setDropFirstLetterSkpBox(true)
    // } else if (arrayOfIgnoredChars.indexOf(firstElement?.toUpperCase()) !== -1 && firstElement.toUpperCase() !== 'R' && skpBoxValue.length > 1 && !dropFirstLetterSkpBox) {
    //   skpBoxValue = skpBoxValue.substring(1)
    //   setDropFirstLetterSkpBox(true)
    // }
    return e.target.value = ('' + skpBoxValue).toUpperCase()
  }
  // console.log('url', selectAssetSequenceUrl[0].label)
  const validateSkpBoxId = async (e) => {
    if (e.code === 'Enter' || e.keyCode === 13) {
      setBusy()
      setSelectedSkpBoxnum(e.target.value)
      let requests = []
      let rejectedReqs = []
      arrRefs[BOX_ID].current.setErrorMsg('')
      let boxData = await localGdeTransactionLite.getBoxById(e.target.value)
      const firstElement = Array.from(e.target.value)[0]
      const arrayOfIgnoredChars = appConstants.ignoreBarcodeScanCharacters
      if (boxData.docs.length === 0 && arrayOfIgnoredChars.indexOf(firstElement.toUpperCase()) !== -1) {
        const skpBoxValue = e.target.value.substring(1)
        boxData = await localGdeTransactionLite.getBoxById(skpBoxValue)
        if (boxData.docs.length !== 0) {
          arrRefs[BOX_ID]?.current?.setValue(skpBoxValue)
        }
      }
      const [lineOfBusiness, assetType, , templateType, skpEncoding, fileSequence] = await localGdeTransactions.getGdeConfig()
      const activeSequence = []
      Object.keys(fileSequence).forEach((key) => {
        const file = fileSequence[key]
        if (file && file?.isActive) {
          activeSequence.push({ value: file.seqName, label: file.seqName })
        }
      })
      setSelectAssetSequence(activeSequence)
      // setSelectAssetSequence(Object.entries(fileSequence).map(([key, value]) => ({ value: value.seqName, label: value.seqName })))
      setSelectAssetSequenceUrl(Object.entries(fileSequence).map(([key, value]) => ({ value: value.seqImgUrl, label: value.seqName })))
      if (boxData.docs.length === 0) {
        setIsValidBoxId(false)
        setDropFirstLetterSkpBox(false)
        arrRefs[BOX_ID].current.setErrorMsg(t('smartCatalog.invalidBox'))
      }
      if (boxData.docs.length > 1) {
        boxData.forEach((doc) => {
          if (doc?.data()?.isIdpFail) {
            rejectedReqs.push(doc?.data())
          } else if ((doc?.data()?.status === 'In Progress' || 'pending') && (!doc?.data()?.isIdpFail)) {
            requests.push(doc?.data())
          }
        })
        // Don't load images here - just store the original references
        // const requestWithNatsImg = await natsService.getNatsURL(requests, constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG)
        // const rejectedReqsWithNatsImg = await natsService.getNatsURL(rejectedReqs, constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG)
        setState({ showMultipleRequestsForm: true, requestDocs: requests, rejectedReqsDocs: rejectedReqs })
        getTemplateFields(requests)
        showMultiReqsDialog()
      } else if (boxData.docs.length === 1) {
        // boxData.forEach((doc) => {
        for (const doc of boxData.docs) {
          if (doc?.data()?.dataLocation) {
            setSelectedWorkflow(doc?.data()?.dataLocation)
          }
          let customFields = []
          Object.keys(doc?.data()?.template).forEach(function (key) {
            customFields.push(key)
          })
          const tempReq = doc?.data()
          // const requestWithNatsImg = await getNatsURL([tempReq], constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG)
          // const requestWithNatsImg = await natsService.getNatsURL([tempReq], constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG)
          
          requests.push(doc?.data)
          setNewAssetType(doc?.data()?.assetType)
          setIsValidBoxId(true)
          setState({
            requests: requests,
            activityData: tempReq,
            activityId: doc?.id,
            customFields: customFields,
            newTemplateId: doc?.data()?.requestId,
            templateFields: doc?.data()?.template,
            templateFieldsLocked: doc?.data()?.templateLocked,
            unlockedTemplateFields: [],
            lockedTemplateFields: [],
          })
          if (doc?.data()?.isIdpFail) {
            setState({ isSingleRequest: true })
            showRejectedImgsModal()
          } else if (doc?.data()?.isRetake) {
            setState({ isSingleRequest: true })
            showRetakeImgsModal()
          }
        // })
        }
        const requestData = await localGdeTransactionLite.getRequestById(getState()?.activityData?.requestId)
        setConfidence(requestData?.confidence? requestData?.confidence : 0)
        let requestParentAssetType = false
        Object.values(assetType).forEach((assetTypeEach) => {
          if (assetTypeEach?.subAssetTypes) {
            Object.values(assetTypeEach?.subAssetTypes).forEach((subAssetTypeEach) => {
              if (subAssetTypeEach.name === getState()?.activityData?.assetType && !requestParentAssetType) {
                requestParentAssetType = assetTypeEach.name
              }
            })
          }
        })
        const selectAssetTypes = []
        Object.values(assetType).forEach((assetTypeEach) => {
          if (assetTypeEach?.subAssetTypes && assetTypeEach.name === requestParentAssetType) {
            Object.values(assetTypeEach?.subAssetTypes).forEach((subAssetTypeEach) => {
              if (subAssetTypeEach?.isActive) {
                selectAssetTypes.push({ value: subAssetTypeEach.name, label: subAssetTypeEach.name })
              }
            })
          }
        })

        const getBoxImages = await localGdeTransactionLite.getImages(getState().activityId, getState()?.activityData?.skpBoxNbr)
        if (getBoxImages.size > 0) {
          setImgDocCount(getBoxImages.size)
        }
        setState({ selectAssetType: selectAssetTypes })
      }

      // if (getState()?.activityData?.assetType) {
      //   setTimeout(() => {
      //     arrRefs[SELECT_ASSET_TYPE].current.setValue(getState()?.activityData?.assetType)
      //   }, 1000)
      // }
      clearBusy()
    }
  }
  const fetchAndCalculateImageCount = async () => {
    try {
      const activityId = getState()?.activityId
      const activityDatas = getState()?.activityData
      const singleRequested = activityDatas?.requestId
      const selectedRequest = getState()?.selectedRequest
      const requestId = selectedRequest || singleRequested
      if (!requestId) {
        return
      }
      const images = await localGdeTransactionLite.getImagByActivityId(activityId)
      const docs = images?.docs || []
      const documentDetails = docs.map(doc => {
        const data = doc.data()
        return {
          imgDetails: data.imgDetails.numOfFiles,
        }
      })

      let totalCount = 0

      documentDetails.forEach(doc => {
        if (Array.isArray(doc.imgDetails)) {
          doc.imgDetails.forEach(value => totalCount += Number(value))
        } else {
          totalCount += Number(doc.imgDetails)
        }
      })

      setTotalImageCount(totalCount)
    } catch (error) {
      console.error('Error fetching or processing images:', error)
    }
  }
  useEffect(() => {
    sortedBy(selectLvls)
  }, [selectLvls])

  useEffect(() => {
    fetchAndCalculateImageCount()
  }, [getState().activityId, saveImgTrnsSuccess])
  const onCheckBoxSelectionReq = (requestId) => {
    setState({ selectedRequest: requestId, isRejectedImage: false, isRetakeImage: false })
  }

  const ContentForReqsBox = () => {
    return (
      <RequestTemplateFormat
        tableRef={tableRef}
        getPageData={getTemplateFields}
        title={getState().templateName}
        formTemplates={formTemplate}
        arrRefs={arrRefs}
        isEdit={false}
        getState={getState}
        selectedRecord={onCheckBoxSelectionReq}
        fromMultiReqs={true}
        fromImageCapture={true}
        onImageClick={handleImageClick} // Passed image click handler
        reportFor={'multiRequestSelection'}
      />
    )
  }

  const convertUTCDateToLocalDate = (date) => {
    const date2 = new Date(date)
    const dateString = date2.toLocaleDateString()
    const timeString = date2.toLocaleTimeString()
    const newDate = `${dateString}, ${timeString}`
    return newDate
  }

  const getImgFields = async () => {
    let fields
    fields = getState()?.rejectedImages
    const result = fields.map(doc => {
      const timestamp = convertUTCDateToLocalDate(doc?.createdTS)
      return {
        boxId: doc?.skpBoxNbr,
        barCode: doc?.barcode || '-',
        status: doc?.status,
        idpStatus: doc?.idp?.status,
        exception: doc?.idp?.exception,
        assetType: doc?.assetType,
        userName: doc?.username,
        createdTS: timestamp,
        images: doc?.imgDetails?.imgPath,
        requestId: doc?.requestId,
        id: doc?.id,
        sequence: doc?.sequence,
        templateFields: doc?.template,
        templateLocked: doc?.templateLocked
      }
    })
    const copyResult = JSON.parse(JSON.stringify(result))
    for (let i = 0;  i < copyResult.length; i++) {
      const arrImg = []
      for  (const img of copyResult[i]?.images) {
        // const tempImg = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_ASSET_IMG, img)
        // const tempImg = await natsService.getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_ASSET_IMG, img)
        const tempImg = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_ASSET_IMG, img)
        arrImg.push(tempImg)
      }
      copyResult[i].images = [...arrImg]
    }
    setState({ selectedRejectImageDocs: copyResult })
    return copyResult
  }

  const getRetakeImgFields = async () => {
    let fields
    fields = getState()?.retakeImages
    const result = fields.map(doc => {
      const timestamp = convertUTCDateToLocalDate(doc?.createdTS)
      return {
        boxId: doc?.skpBoxNbr,
        status: doc?.status,
        idpStatus: doc?.idp?.status,
        exception: doc?.idp?.exception,
        assetType: doc?.assetType,
        userName: doc?.username,
        createdTS: timestamp,
        images: doc?.imgDetails?.imgPath,
        requestId: doc?.requestId,
        id: doc?.id,
        sequence: doc?.sequence,
        templateFields: doc?.template,
        templateLocked: doc?.templateLocked
      }
    })
    const copyResult = JSON.parse(JSON.stringify(result))
    for (let i = 0;  i < copyResult.length; i++) {
      const arrImg = []
      for  (const img of copyResult[i]?.images) {
        // const tempImg = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_ASSET_IMG, img)
        // const tempImg = await natsService.getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_ASSET_IMG, img)
        const tempImg = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_ASSET_IMG, img)
        arrImg.push(tempImg)
      }
      copyResult[i].images = [...arrImg]
    }
    setState({ selectedRetakeImageDocs: copyResult })
    return copyResult
  }

  const onCheckBoxSelectionImageReq = (id) => {
    if (id) {
      getState()?.selectedRejectImageDocs.forEach((imageDoc) => {
        if (imageDoc?.id === id) {
          setState({ selectedRejectImage: imageDoc })
        }
      })
    } else {
      setState({ selectedRejectImage: {} })
    }
    setState({ isRejectedImage: true })
  }

  const onCheckBoxSelectionRetakeImageReq = (id) => {
    if (id) {
      getState()?.selectedRetakeImageDocs.forEach((imageDoc) => {
        if (imageDoc?.id === id) {
          setState({ selectedRetakeImage: imageDoc })
        }
      })
    } else {
      setState({ selectedRetakeImage: {} })
    }
    setState({ isRetakeImage: true })
  }

  const ContentForRejsImgsBox = (props) => {
    return (
      <ImageTemplateFormat
        tableRef={tableRef}
        wmscode={props.wmsC}
        assetType={props.assetT}
        getPageData={getImgFields}
        title={getState().templateName}
        formTemplates={formTemplate}
        arrRefs={arrRefs}
        isEdit={false}
        getState={getState}
        selectedRecord={onCheckBoxSelectionImageReq}
        fromMultiReqs={true}
      />
    )
  }

  const ContentForRetakeImgsBox = () => {
    return (
      <RetakeImageTemplateFormat
        tableRef={tableRef}
        getPageData={getRetakeImgFields}
        title={getState().templateName}
        formTemplates={formTemplate}
        arrRefs={arrRefs}
        isEdit={false}
        getState={getState}
        selectedRecord={onCheckBoxSelectionRetakeImageReq}
        fromMultiReqs={true}
      />
    )
  }

  const closeDialog = () => {
    if (Object.keys(getState()?.selectedRejectImage).length === 0) {
      errorToast({ message: t('toast.selectImage'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
    } else {
      setState({ templateFields: getState()?.selectedRejectImage?.templateFields, templateFieldsLocked: getState()?.selectedRejectImage?.templateLocked })
      closeGeneralDialog()
    }
  }

  const closeDialogRetakeImage = () => {
    if (Object.keys(getState()?.selectedRetakeImage).length === 0) {
      errorToast({ message: t('toast.selectImage'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
    } else {
      setState({ templateFields: getState()?.selectedRetakeImage?.templateFields, templateFieldsLocked: getState()?.selectedRetakeImage?.templateLocked })
      closeGeneralDialog()
    }
  }

  const showRejectedImgsModal = async () => {
    setBusy()
    let imgDocs = []
    let imgIndexes = []
    const images = await localGdeTransactionLite.getImagesByActivityId(getState()?.activityId)
    let wmsC
    let assetT
    for (let index = 0; index < images?.docs?.length; index++) {
      const document = images?.docs[index]?.data()
      document.sequence = index + 1
      imgIndexes.push(document)
    }
    imgIndexes.forEach((img) => {
      wmsC = img?.wmsCode
      assetT = img?.assetType
      if (img?.idp?.status === 'Failure') {
        imgDocs.push(img)
      }
    })
    setState({ rejectedImages: imgDocs, isRejectedImageModal: true })
    openGeneralDialog({
      title: t('smartCatalog.rejectedImages'),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <ContentForRejsImgsBox wmsC={wmsC} assetT={assetT} />,
      buttons: <ButtonsForSaveAndAssignJob arrRefs={arrRefs} onNewTemplateSelection={getState()?.isSingleRequest ? closeDialog : onRequestSelection} />,
      closeX: false
    })
    clearBusy()
  }

  const showRetakeImgsModal = async () => {
    setBusy()
    let imgDocs = []
    let imgIndexes = []
    const images = await localGdeTransactionLite.getImagesByActivityId(getState()?.activityId)
    for (let index = 0; index < images?.docs?.length; index++) {
      const document = images?.docs[index]?.data()
      document.sequence = index + 1
      imgIndexes.push(document)
    }
    imgIndexes.forEach((img) => {
      if (img?.status === 'Retake') {
        imgDocs.push(img)
      }
    })
    setState({ retakeImages: imgDocs, isRetakeImageModal: true })
    openGeneralDialog({
      title: t('smartCatalog.retakeImages'),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <ContentForRetakeImgsBox />,
      buttons: <ButtonsForSaveAndAssignJob arrRefs={arrRefs} onNewTemplateSelection={getState()?.isSingleRequest ? closeDialogRetakeImage : onRequestSelection} />,
      closeX: false
    })
    clearBusy()
  }

  // const showRejsReqsModal = async () =>  {
  //   let imgDocs = []
  //   const images = await localGdeTransactionLite.getImagesByActivityId(arrRefs[BOX_ID].current.getValue(), getState()?.selectedRequest)
  //   images.forEach((img) => {
  //     if (img?.data()?.idp?.status === 'Fail') {
  //       imgDocs.push(img?.data())
  //     }
  //   })
  //   setState({ rejectedImages: imgDocs })
  //   showRejectedImgsDocs()
  // }

  const showMultiReqsDialog = () => {
    openGeneralDialog({
      title: t('smartCatalog.requests'),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <ContentForReqsBox />,
      buttons: <ButtonsForSaveAndAssignJob arrRefs={arrRefs} onNewTemplateSelection={onRequestSelection} />,
      closeX: false
    })
  }


  const getTemplateFields = async (requests) => {
    let fields
    fields = getState()?.rejectedReqsDocs.concat(getState()?.requestDocs)

    const result = fields.map(async (doc) => {
      const templateFields = Object.keys(doc.template)

      const requestId = doc.requestId
      const requestData = await localGdeTransactionLite.getRequestById(requestId)

      let getTemplateLockedFields = []
      { doc.templateLocked ? getTemplateLockedFields = Object.keys(doc?.templateLocked) : [] }
      return {
        isIdpFail: doc?.isIdpFail,
        status: doc?.status,
        requestId: doc.requestId,
        // customTemplateName: requestData?.customTemplateName,
        customRequestName: requestData?.customRequestName,
        requestFields: templateFields,
        lockedFields: getTemplateLockedFields,
        // isChecked: false,
        imgReference: doc?.imgReference
      }
    })
    // setState({ requests: result })
    // console.log(result)
    // return result

    const resolvedResults = await Promise.all(result)
    setState({ requests: resolvedResults })
    return resolvedResults
  }

  const handleCloseDialog = () => {
    setDialogOpen(false)
  }
  const handleOpenDialog = () => {
    const state = getState()
    const exceptionNote = state.imageExceptionNote
    const boxExceptionNote = state.boxExceptionNote
    if (totalImageCount === 0) {
      if ((exceptionNote && exceptionNote.trim() !== '') || (boxExceptionNote && boxExceptionNote.trim() !== '')) {
        setDialogOpen(false)
        closeBox()
      } else {
        errorToast({ message: t('smartCatalog.exceptionNoteMsg'), title: t('toast.error'), autoHideDuration: 3000 })
      }
    } else {
      setDialogOpen(true)
    }
  }

  const handleConfirmCloseBox = async () => {
    await closeBox()
    handleCloseDialog()
  }


  const saveImages = async (filesCount, BoxesCount, reqData) => {
    // Prevent multiple simultaneous calls
    if (isSavingImagesRef.current) {
      return
    }
  

  
    isSavingImagesRef.current = true
    try {
      setBusy() // Show loading indicator
      
      const imgDetails = {
        imgPath: getState().imagePaths,
        imgNUID: getState().imageNUID,
        numOfBoxes: BoxesCount,
        numOfFiles: filesCount,
      }
      
      let unlockedFields = []
      if (getState()?.lockedTemplateFields.length === 0 && getState()?.unlockedTemplateFields.length === 0) {
        unlockedFields = getState()?.templateFields
      } else {
        unlockedFields = getState()?.unlockedTemplateFields
      }
      
      // Validate template fields exist
      if (!unlockedFields || Object.keys(unlockedFields).length === 0) {
        throw new Error('Template fields are missing. Please ensure a template is selected.')
      }
      
      unlockedFields = updateTemplateFields(unlockedFields, confidence)
      let isException = false
      let exceptionNote = ''
      if (getState().imageExceptionNote) {
        exceptionNote = getState().imageExceptionNote
        isException = true
      }
  
      let refTemplateId = getState()?.activityData?.templateId
      if (getState()?.selectedTemplate) {
        refTemplateId = getState()?.selectedTemplate
      }
      
      let RefImage = getState()?.activityData?.initialImgReferenceNats || getState()?.activityData?.imgReference || ''
      if (selectedRefImage && typeof selectedRefImage === 'string' && selectedRefImage.trim() !== '') {
        RefImage = selectedRefImage
      }
      
      let RefImageGsPath = getState()?.activityData?.imgReferenceURI || ''
      if (getState()?.selectedRefImageGsPath && typeof getState()?.selectedRefImageGsPath === 'string' && getState()?.selectedRefImageGsPath.trim() !== '') {
        RefImageGsPath = getState()?.selectedRefImageGsPath
      }
      
      const imageData = {
        accountLevel1: getState()?.activityData?.accountLevel1 || '',
        accountLevel2: getState()?.activityData?.accountLevel2 || '',
        accountLevel3: getState()?.activityData?.accountLevel3 || '',
        actionTs: (new Date()).toISOString(),
        activityId: getState().activityId,
        docId: getState().activityId,
        assetType: newAssetType,
        fileSequence: sequences,
        isException: isException,
        exceptionNote: exceptionNote,
        countryCode: getState()?.activityData?.countryCode,
        building: getState().activityData?.building || '',
        custBoxNbr: getState().activityData?.custBoxNbr || '',
        district: getState().activityData?.district || '',
        lob: getState().activityData?.lob || '',
        orderId: getState().activityData?.orderId || '',
        requestId: getState().activityData?.requestId || '',
        templateId: refTemplateId,
        skpBoxNbr: getState().activityData?.skpBoxNbr || '',
        status: constants.activityStatus.submitted,
        template: unlockedFields,
        templateLocked: getState()?.lockedTemplateFields || {},
        imgReference: RefImage || '',
        imgReferenceURI: RefImageGsPath || '',
        imgDetails: imgDetails,
        isProcessed: false,
        isPublished: false,
        isIdpFail: false,
        templateName: getState().activityData?.templateName || '',
        createdTS: (new Date()).toISOString(),
        updatedTS: (new Date()).toISOString(),
        username: username,
        workerId: workerId,
        srcSystem: 'web',
        isActive: true,
        inBQ: false,
        idp: {
          statusCode: '',
          status: '',
          exception: '',
          hitl: {}
        },
        idpResponse: {},
        idp_message_id: '',
        messageId: '',
        processedAt: '',
        publishedAt: '',
        wmsCode: getState()?.activityData?.wmsCode || '',
        wmsRegion: getState()?.activityData?.wmsRegion ? getState()?.activityData?.wmsRegion : '',
        dataLocation: reqData?.dataLocation || '',
        activityName: reqData?.activityName || '',
        activityType: reqData?.activityType || ''
      }
  
      const rejectedImageData = {
        accountLevel1: getState()?.activityData?.accountLevel1 || '',
        accountLevel2: getState()?.activityData?.accountLevel2 || '',
        accountLevel3: getState()?.activityData?.accountLevel3 || '',
        idp: {
          statusCode: '',
          status: '',
          exception: '',
          hitl: {}
        },
        idpResponse: {},
        isPublished: false,
        isProcessed: false,
        processedAt: '',
        publishedAt: '',
        messageId: '',
        idp_message_id: '',
        status: constants.activityStatus.submitted,
        updatedTS: (new Date()).toISOString(),
        // templateImage: '',
        // templateImageURI: '',
        imgDetails: imgDetails,
        template: unlockedFields,
        templateLocked: getState()?.lockedTemplateFields || {},
        isException: isException,
        exceptionNote: exceptionNote,
        username: username,
        workerId: workerId,
        srcSystem: 'web',
        templateId: refTemplateId,
        imgReference: RefImage || '',
        imgReferenceURI: RefImageGsPath || '',
      }
  
      const retakeImageData = {
        accountLevel1: getState()?.activityData?.accountLevel1 || '',
        accountLevel2: getState()?.activityData?.accountLevel2 || '',
        accountLevel3: getState()?.activityData?.accountLevel3 || '',
        idp: {
          statusCode: '',
          status: '',
          exception: '',
          hitl: {}
        },
        idpResponse: {},
        isPublished: false,
        isProcessed: false,
        processedAt: '',
        publishedAt: '',
        messageId: '',
        idp_message_id: '',
        status: constants.activityStatus.submitted,
        updatedTS: (new Date()).toISOString(),
        // templateImage: '',
        // templateImageURI: '',
        imgDetails: imgDetails,
        template: unlockedFields,
        templateLocked: getState()?.lockedTemplateFields || {},
        isException: isException,
        exceptionNote: exceptionNote,
        username: username,
        workerId: workerId,
        srcSystem: 'web',
        templateId: refTemplateId,
        imgReference: RefImage || '',
        imgReferenceURI: RefImageGsPath || '',
      }
  
      const updateAfterPublish = {
        isPublished: true,
        isProcessed: false,
        publishedAt: (new Date()).toISOString()    
      }
  
      let imgId
      try {
        if (getState()?.isRejectedImage) {
          imgId = getState()?.selectedRejectImage?.id
          if (!imgId) {
            throw new Error('Rejected image ID is missing')
          }
          await localGdeTransactions.updateImage(imgId, rejectedImageData)
        } else if (getState()?.isRetakeImage) {
          imgId = getState()?.selectedRetakeImage?.id
          if (!imgId) {
            throw new Error('Retake image ID is missing')
          }
          await localGdeTransactions.updateImage(imgId, retakeImageData)
        } else {
          // Validate imageData before saving
          if (!imageData.activityId) {
            throw new Error('Activity ID is required')
          }
          if (!imageData.assetType) {
            throw new Error('Asset type is required')
          }
          if (!imageData.template || Object.keys(imageData.template).length === 0) {
            throw new Error('Template fields are required')
          }
          
          const saveImgTrnsSuccess = await localGdeTransactions.saveActivityImages(imageData)
          imgId = saveImgTrnsSuccess
          
          if (!imgId) {
            throw new Error('Failed to save image: No ID returned from database')
          }
          
          if (filesCount && saveImgTrnsSuccess) {
            SetSaveImgTrnsSuccess(saveImgTrnsSuccess)
          }
        }
      } catch (saveError) {
        console.error('Error saving image to database:', saveError)
        throw new Error(`Database save failed: ${saveError.message || saveError}`)
      }
      
      if (imgId) {
        try {
          const imgData = await localGdeTransactions.getImageData(imgId)
          if (!imgData) {
            throw new Error('Failed to retrieve saved image data')
          }
          imgData.id = imgId
          
          // Check if natsService is available
          if (!natsService) {
            console.warn('NATS service is not available, skipping publish')
            // Update image without NATS publish
            await localGdeTransactions.updateImage(imgId, {...updateAfterPublish, id: imgId})
          } else {
            // Publish to NATS with error handling
            const { publishedData, msgId } = await natsService.publishImgData(constants.LOCAL_NATS_SERVER, {...imgData, ...updateAfterPublish})
            if (msgId) { 
              await localGdeTransactions.updateImage(imgId, {...updateAfterPublish, id: imgId, messageId: msgId}) 
            } else {
              // Update without messageId if publish didn't return one
              await localGdeTransactions.updateImage(imgId, {...updateAfterPublish, id: imgId})
            }
          }
        } catch (publishError) {
          console.error('Error publishing image to NATS:', publishError)
          // Still update the image even if NATS publish fails
          try {
            await localGdeTransactions.updateImage(imgId, {...updateAfterPublish, id: imgId})
          } catch (updateError) {
            console.error('Error updating image after NATS failure:', updateError)
          }
          // Show warning but don't fail the entire operation
          errorToast({ 
            message: t('toast.natsPublishError'), 
            title: t('dataEntry.warning'),
            autoHideDuration: 5000,
            isBlocking: false 
          })
        }
      }
      
      // Close the modal first
      handleShowModal(false)
      closeGeneralDialog()
      
      successToast({ message: t('toast.imagesSaved'), title: t('toast.success') }, 5)
      if (getState()?.isRejectedImage) {
        function selectedImage(img) {
          return img.id !== getState()?.selectedRejectImage?.id
        }
        let newRejectedImages = getState()?.rejectedImages
        let arr = newRejectedImages.filter(selectedImage)
        if (arr.length !== 0) {
          showRejectedImgsModal()
        } else {
          closeBox()
        }
      } else if (getState()?.isRetakeImage) {
        function selectedImage(img) {
          return img.id !== getState()?.selectedRetakeImage?.id
        }
        let newRetakeImages = getState()?.retakeImages
        let arr = newRetakeImages.filter(selectedImage)
        if (arr.length !== 0) {
          showRetakeImgsModal()
        } else {
          closeBox()
        }
      }
      resetData('Images')
    } catch (error) {
      // Enhanced error handling with detailed logging
      console.error('Error saving images - Full error:', error)
      console.error('Error stack:', error.stack)
      console.error('Current state:', {
        activityId: getState().activityId,
        assetType: newAssetType,
        imagePaths: getState().imagePaths?.length,
        hasTemplate: !!getState().templateFields && Object.keys(getState().templateFields).length > 0
      })
      
      errorToast({ 
        message: t('toast.imageSaveError', { errorMessage: error.message || 'Unknown error' }),
        title: t('toast.error'),
        autoHideDuration: 5000,
        isBlocking: false 
      })
    } finally {
      clearBusy() // Clear loading indicator
      isSavingImagesRef.current = false
    }
  }


  const closeBox = async () => {
    let isException = false
    let exceptionNote = ''
    if (getState().boxExceptionNote) {
      exceptionNote = getState().boxExceptionNote
      isException = true
    }
    const activityDataToUpdate = {
      status: constants.activityStatus.completed,
      updatedTS: (new Date()).toISOString(),
      exceptionNote: exceptionNote,
      isException: isException,
    }

    if (getState()?.isRejectedImage) {
      activityDataToUpdate.isIdpFail = false
      activityDataToUpdate.isProcessed = false
      activityDataToUpdate.isPublished = false
    } else if (getState()?.isRetakeImage) {
      activityDataToUpdate.isIdpFail = false
      activityDataToUpdate.isProcessed = false
      activityDataToUpdate.isPublished = false
      activityDataToUpdate.isRetake = false
    }

    await localGdeTransactions.updateActivityData(getState().activityId, activityDataToUpdate)
    successToast({ message: t('toast.boxScanComplete'), title: t('toast.success') }, 10)
    resetData('Activity')
  }

  const BottomPaddedButton = props =>
    <>
      <ThemeButton {...props} />
      <VerticalDivider />
    </>

  const closeTemplateDialog = () => {
    closeGeneralDialog()
  }

  const ButtonsForTemplateAssign = props =>
    <>
      <BottomPaddedButton color='primary' variant='outlined' onClick={props.closeTemplateDialog}>buttons.cancel</BottomPaddedButton>
      <BottomPaddedButton color='primary' variant='contained' onClick={props.onNewTemplateSelection}>buttons.cancelAndGoBack</BottomPaddedButton>
    </>

  ButtonsForTemplateAssign.propTypes = {
    arrRefs: PropTypes.array,
    saveAndAssignJob: PropTypes.func,
    onNewTemplateSelection: PropTypes.func,
    closeTemplateDialog: PropTypes.func
  }

  const ButtonsForSaveAndAssignJob = props => {

    const handleNewTemplateSelection = async () => {

      try {

        await fetchAndCalculateImageCount()

        props.onNewTemplateSelection()

      } catch (error) {

        console.error('Error calculating image count:', error)

      }

    }

    return (

      <BottomPaddedButton

        color='primary'

        variant='outlined'

        onClick={handleNewTemplateSelection}

      >

        buttons.cancelAndGoBack

      </BottomPaddedButton>

    )

  }



  ButtonsForSaveAndAssignJob.propTypes = {
    arrRefs: PropTypes.array,
    saveAndAssignJob: PropTypes.func,
    onNewTemplateSelection: PropTypes.func
  }

  const onTemplateSelection = async () => {
    if (getState().newTemplateId !== getState()?.activityData?.requestId) {
      const requestData = await localGdeTransactionLite.getTemplateById(getState().newTemplateId)
      let customFields = []
      Object.keys(requestData?.template).forEach(function (key) {
        customFields.push(key)
      })

      setState({
        customFields: customFields,
        templateFields: requestData?.template,
        templateFieldsLocked: requestData?.templateLocked,
        unlockedTemplateFields: [],
        lockedTemplateFields: [],
      })
    }
    successToast({ message: t('toast.templateChangedSucessfully'), title: t('toast.success') }, 5)
    closeGeneralDialog()
  }
  const onTemplateandrefSelection = async () => {
    if (getState().newTemplateId !== getState()?.activityData?.requestId) {
      const requestData = await localGdeTransactionLite.getTemplateById(getState().newTemplateId)
      let customFields = []
      Object.keys(requestData?.template).forEach(function (key) {
        customFields.push(key)
      })

      setState({
        customFields: customFields,
        templateFields: requestData?.template,
        templateFieldsLocked: requestData?.templateLocked,
        unlockedTemplateFields: [],
        lockedTemplateFields: [],
      })
      requestData.boxId = selectedSkpBoxnum
      openUpdateRefImageDialog(requestData, 'templateAndRef')
    }
  }

  const handleSelectedRefImage = async (data, data1, mode = 'refOnly') => {
    // let updtImg = ''
    // if (typeof(data) === 'string' && data.includes('nats')) {
    //   // updtImg = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, data)
    //   // updtImg = await natsService.getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, data)
    //   updtImg = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, data)
    // }
    // setSelectedNatsRefImage(updtImg)
    setSelectedRefImage(data)
    setState({
      selectedRefImageGsPath: data1,
    })
    setLoadedRefImageUrl(null)
    
    if (typeof(data) === 'string' && data.includes('nats')) {
      loadImageFromNats(data).then(updtImg => {
        if (updtImg) {
          setSelectedNatsRefImage(updtImg)
          setLoadedRefImageUrl(updtImg)
        }
      }).catch(error => {
        console.error('Error loading reference image:', error)
      })
    } else if (data && (data.startsWith('http://') || data.startsWith('https://') || data.startsWith('data:'))) {
      setSelectedNatsRefImage(data)
      setLoadedRefImageUrl(data)
    }
    
    if (mode === 'refOnly') {
      successToast(
        { message: t('toast.RefImgChangedSucessfully'), title: t('toast.success') }, 5);
    } else if (mode === 'templateAndRef') {
      successToast(
        { message: t('toast.templateAndRefChangedSucessfully'), title: t('toast.success') }, 5);
    }
    setCameraRef(prev => prev + 1)
  }

  const openUpdateRefImageDialog = (rowData, mode) => {
    openGeneralDialog({
      title: t('templates.refImageUpdate'),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <TemplateAndRefOnImgCature 
        handleImageUploadToNats={handleImageUploadToNats} 
        rowData={rowData} 
        setCameraRef={setCameraRef} 
        selectedTemplateData={(data, data1) => handleSelectedRefImage(data, data1, mode)} 
        onClose={onCancel}
        natsService={natsService}
        getImgFromNats={getImgFromNats}
      />,
      closeX: false
    })
  }

  const loadImageFromNats = async (imgReference) => {
    if (!imgReference) return null
    
    return await getImgFromNats(
      constants.LOCAL_NATS_SERVER,
      constants.LOCAL_AI_REF_IMG,
      imgReference,
      true // Enable caching
    )

    // --- OLD CODE ---
    // // Check cache first
    // if (imageCache.current.has(imgReference)) {
    //   return imageCache.current.get(imgReference)
    // }
    // 
    // // Check if it's a NATS image
    // if (imgReference.includes('nats')) {
    //   try {
    //     const imageUrl = await natsService.getImgFromNats(
    //       constants.LOCAL_NATS_SERVER, 
    //       constants.LOCAL_AI_REF_IMG, 
    //       imgReference
    //     )
    //     if (imageUrl) {
    //       imageCache.current.set(imgReference, imageUrl)
    //       return imageUrl
    //     }
    //   } catch (error) {
    //     console.error('Error loading image from NATS:', error)
    //     return null
    //   }
    // }
    // 
    // // For non-NATS images, return as-is
    // return imgReference
  }

  useEffect(() => {
    const loadReferenceImage = async () => {
      // Get the image reference from state - prioritize selectedRefImage if set
      const imgRef = selectedRefImage || 
                     selectedNatsRefImage || 
                     getState().activityData?.imgReference || 
                     getState().activityData?.initialImgReferenceNats
      
      // If no reference, clear the loaded image
      if (!imgRef) {
        setLoadedRefImageUrl(null)
        return
      }
      
      // If it's already a valid URL (not a NATS reference), use it directly
      if (imgRef && (imgRef.startsWith('http://') || imgRef.startsWith('https://') || imgRef.startsWith('data:'))) {
        setLoadedRefImageUrl(imgRef)
        return
      }
      
      // If it's a NATS reference, load it
      if (imgRef.includes('nats') || imgRef) {
        setIsLoadingRefImage(true)
        try {
          const imageUrl = await loadImageFromNats(imgRef)
          if (imageUrl) {
            setLoadedRefImageUrl(imageUrl)
          } else {
            setLoadedRefImageUrl(null)
          }
        } catch (error) {
          console.error('Error loading reference image:', error)
          setLoadedRefImageUrl(null)
        } finally {
          setIsLoadingRefImage(false)
        }
      }
    }
    
    loadReferenceImage()
  }, [selectedRefImage, selectedNatsRefImage, getState().activityData?.imgReference, getState().activityData?.initialImgReferenceNats])
  
  useEffect(() => {
    if (!imageRef.current) return
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Image is in view, trigger load if not already loaded
            const imgRef = selectedNatsRefImage || getState().activityData?.imgReference || getState().activityData?.initialImgReferenceNats
            if (imgRef && !loadedRefImageUrl && !isLoadingRefImage) {
              // The loadReferenceImage logic will be triggered by the dependency array
            }
            observer.unobserve(entry.target)
          }
        })
      },
      { rootMargin: '50px' }
    )
    
    observer.observe(imageRef.current)
    
    return () => {
      if (imageRef.current) {
        observer.unobserve(imageRef.current)
      }
    }
  }, [imageRef.current, loadedRefImageUrl, isLoadingRefImage])

  const handleImageClick = async (imgReference) => {
    if (!imgReference) {
      setImageError(true)
      setLoadingImage(false)
      setSelectedImage(null)
      return
    }
    
    // --- OLD CODE ---
    // // Check cache first
    // if (imageCache.current.has(imgReference)) {
    //   const cachedImage = imageCache.current.get(imgReference)
    //   if (cachedImage) {
    //     isDialogOpenRef.current = true
    //     setSelectedImage(cachedImage)
    //     setLoadingImage(false)
    //     setImageError(false)
    //     return
    //   }
    // }
    
    isDialogOpenRef.current = true
    // Open dialog immediately with loading state
    setLoadingImage(true)
    setSelectedImage(null)
    setImageError(false)
    
    try {
      const imageUrl = await loadImageFromNats(imgReference)
      if (isDialogOpenRef.current) {
        if (imageUrl) {
          setSelectedImage(imageUrl)
          setImageError(false)
        } else {
          setSelectedImage(null)
          setImageError(true)
        }
      }
    } catch (error) {
      console.error('Error loading image:', error)
      if (isDialogOpenRef.current) {
        setSelectedImage(null)
        setImageError(true)
      }
    } finally {
      if (isDialogOpenRef.current) {
        setLoadingImage(false)
      }
    }
  }
  
  const handleCloseImageDialog = () => {
    isDialogOpenRef.current = false
    setSelectedImage(null)
    setLoadingImage(false)
    setImageError(false)
  }

  const ImageContainer = () => {
    const isOpen = loadingImage || !!selectedImage || imageError
    
    if (!isOpen) return null
    
    return (
      <Dialog 
        open={isOpen} 
        onClose={handleCloseImageDialog}
        maxWidth="sm"
      >
        <DialogContent>
          <DialogContentText component="div">
            {loadingImage && !selectedImage && !imageError
              ? <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '400px',
                minWidth: '400px',
                gap: 2
              }}>
                <CircularProgress size={40} />
                <Typography variant="body2" color="textSecondary">
                  {t('Search.loading')}
                </Typography>
              </Box>
              : selectedImage && !imageError
                ? <img
                  src={selectedImage}
                  alt="Reference Image"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    display: 'block',
                    margin: '0 auto'
                  }}
                  onLoad={() => setLoadingImage(false)}
                  onError={() => {
                    setSelectedImage(null)
                    setLoadingImage(false)
                    setImageError(true)
                  }}
                />
                : <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: '400px',
                  minWidth: '400px',
                  gap: 2
                }}>
                  <Typography variant="body2" color="textSecondary">
                    {t('smartCatalog.imageNotAvailable')}
                  </Typography>
                </Box>}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImageDialog} color="primary">
            {t('dataEntry.close')}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  const getRequest = async () => {
    let templateData = await localGdeTransactions.getTemplateById_SC(getState()?.activityData?.templateId)
    templateData = templateData.data()
    const data = {
      accountLevel1: templateData?.accountLevel1 || '',
      accountLevel2: templateData?.accountLevel2 || '',
      accountLevel3: templateData?.accountLevel3 || '',
      assetType: templateData?.assetType || '',
      templateType: templateData?.templateType || '',
      wmsInstance: templateData?.wmsCode || '',
    }
    /* const {accountLevel1, accountLevel2, accountLevel3} = data
    setSelectLvls({accountLevel1, accountLevel2, accountLevel3}) */

    const requests = await localGdeTransactions.getRequests(data)
    const requestList = []
    requests.forEach((doc) => {
      requestList.push(doc.data())
    })
    // Don't load images here - just store original references
    // const requestListWithNatsImg = await natsService.getNatsURL(requestList, constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG)
    setState({
      templateData: requestList,
    })
  }


  const getRequestFields = async () => {
    await getRequest()
    const fields = getState().templateData
    fields.sort((a, b) => {
      return (new Date(b.createdTS)) - (new Date(a.createdTS))
    })
    const resultPromises = fields.map(doc => {
      const templateFields = Object.keys(doc.template).map((key) => {
        const data = `${key} (${doc.template[key].fieldId})`
        return data
      })

      return localGdeTransactions.getUserNameById(doc.workerId).then(createdBy => {
        return {
          requestId: doc.templateId,
          requestFields: templateFields,
          customTemplateName: doc.customTemplateName,
          createdBy: createdBy,
          createdOn: doc.createdTS,
          imgReference: doc.imgReference
        }
      })
    })
    const result = await Promise.all(resultPromises)
    return result
  }
  const sortedBy = (selectLvls) => {
    let sortbyMsg = `Lvl1: ${selectLvls.accountLevel1}`
    if (selectLvls.accountLevel2 !== '') {
      sortbyMsg += ` | Lvl2: ${selectLvls.accountLevel2}`
    }
    if (selectLvls.accountLevel3 !== '') {
      sortbyMsg += ` | Lvl3: ${selectLvls.accountLevel3}`
    }
    setSortMsg(sortbyMsg)
  }

  const ContentForDialogBox = ({ sortMsg }) => {
    return (
      <>
        <div>
          <h4>Template sorted by: {sortMsg}</h4>
        </div>
        <RequestTemplateFormat
          tableRef={tableRef}
          getPageData={getRequestFields}
          title={getState().templateName}
          formTemplates={formTemplate}
          arrRefs={arrRefs}
          isEdit={false}
          getState={getState}
          selectedRecord={onCheckBoxSelection}
          currentTemplateId={getState()?.activityData?.templateId}
          fromMultiReqs={false}
          reportFor={'multiRequestSelection'}
          onImageClick={handleImageClick}
        />
      </>
    )
  }

  const onCheckBoxSelection = async (requestId) => {
    if (requestId && requestId !== getState()?.newTemplateId) {
      setState({
        newTemplateId: requestId,
        selectedTemplate: requestId,
      })
    }
  }

  const submitImages = async () => {
    setState({
      showModal: true
    })
    setIsSequence(true)
  }

  const handleShowModal = () => {
    setState({
      showModal: false
    })
  }

  const showExceptionModal = () => {
    setState({
      showExceptionModal: false
    })
  }

  const getExceptionData = async (data) => {
    const { exceptionFor, exceptionNote } = data
    if (exceptionFor === 'Image Exception') {
      setState({
        imageExceptionNote: exceptionNote,
      })
    } else if (exceptionFor === 'Box Exception') {
      setState({
        boxExceptionNote: exceptionNote,
      })
    }
  }

  if (imageCount >= appConstants.totalImagesAllowedToCapture && !getState()?.showModal) {
    errorToast({
      message: t('smartCatalog.imageLimitExceed', { imgLimit: appConstants.totalImagesAllowedToCapture }),
      title: t('toast.error'),
      autoHideDuration: 3000,
      isBlocking: false
    })
  }

  const cropImage = async () => {
    if (typeof cropper !== 'undefined' && imageCount < appConstants.totalImagesAllowedToCapture) {
      try {
        setBusy()
        const croppedImage = cropper.getCroppedCanvas().toDataURL()
        const imageRef = storageRef(storage, `DocumentScanner/gde_${workerId}_${Date.now()}.jpg`)
        const byteString = atob(croppedImage.split(',')[1])
        const mimeString = croppedImage.split(',')[0].split(':')[1].split(';')[0]
        const ab = new ArrayBuffer(byteString.length)
        const ia = new Uint8Array(ab)
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i)
        }
        const blob = new Blob([ab], { type: mimeString })
        const snapshot = await uploadBytes(imageRef, blob)
        const url = await getDownloadURL(snapshot.ref)
        uploadBytes(imageRef, blob)
          .then((snapshot) => {
            getDownloadURL(snapshot.ref)
              .then((url) => {
                setState({
                  imagePaths: getState().imagePaths.concat([url]),
                })
                setImageCount(imageCount + 1)
                prevCropDone.current = true
              })
              .catch((error) => {
                console.log(error.message)
              })
          })
          .catch((error) => {
            console.log(error.message)
          })
        const newImages = {
          src: url,
          alt: url,
        }
        setImgUrl(prevImages => [...prevImages, newImages])

        setPreviewImage(false)
        clearBusy()
      } catch (err) {
        console.error(err.message)
      }
    }
  }
  const cropImageForNats = async () => {
    if (typeof cropper !== 'undefined' && imageCount < appConstants.totalImagesAllowedToCapture) {
      try {
        setBusy()
        const croppedImage = cropper.getCroppedCanvas().toDataURL()
        const imageRef = storageRef(storage, `DocumentScanner/gde_${workerId}_${Date.now()}.jpg`)
        const byteString = atob(croppedImage.split(',')[1])
        const mimeString = croppedImage.split(',')[0].split(':')[1].split(';')[0]
        const ab = new ArrayBuffer(byteString.length)
        const ia = new Uint8Array(ab)
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i)
        }
        const blob = new Blob([ab], { type: mimeString })
        const rename = `nats_assetImg_${workerId}_${Date.now()}.jpg`
        const renamedFile = new File([ab], rename, {
          // type: originalFile.type,
          lastModified: ab.lastModified,
        })
        // const { nuid, name } = await uploadRefImg(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_ASSET_IMG, renamedFile)
        const { nuid, name } = await natsService.uploadRefImg(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_ASSET_IMG, renamedFile, constants.MAX_LOCAL_AI_IMG_UPLOAD)
        setState({
          imagePaths: getState().imagePaths.concat([name]),
          imageNUID: getState().imageNUID.concat([nuid])
        })
        setImageCount(imageCount + 1)
        prevCropDone.current = true
        const newImages = {
          src: name,
          alt: name,
        }
        setImgUrl(prevImages => [...prevImages, newImages])

        setPreviewImage(false)
        clearBusy()
      } catch (err) {
        errorToast({title: t('toast.error'), message: t('messages.unableToSaveImage')})
        console.error('err occured -->', err.message)
      }finally{
        clearBusy()
      }
    }
  }

  // Utility: convert base64 to File
  function dataURLtoFile(dataurl, filename) {
    let arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n)

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }

    return new File([u8arr], filename, { type: mime })
  }

  //  resize image using the react-image-file-resizer
  const resizeImage = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1500,    // Max width
        1500,    // Max height
        "JPEG", // Output format
        80,     // Quality
        0,      // Rotation
        (uri) => resolve(uri), // Callback with resized image (base64)
        "base64"
      )
    })

  const handleTakePhoto = async (dataUri) => {
    if (!selectedWorkflow) {
      errorToast({ message: t('smartCatalog.workflow'), title: t('toast.error') })
      return null
    }

    if (assetType === "Multiple Folders") {
      if (!arrRefs[SELECT_ASSET_SECQUENCE]?.current?.getValue()) {
        errorToast({ message: t('smartCatalog.assetSequenceRequired'), title: t('toast.error') })
        return
      }
    }

    try {
      setBusy()

      // Convert dataUri (base64) to File
      const originalFile = dataURLtoFile(dataUri, "photo.jpg")

      // Resize the file
      const resizedBase64 = await resizeImage(originalFile)

      // Store resized image instead of original
      setImageSrc2(resizedBase64)
      setPreviewImage(true)
      setIsSequence(false)
    } catch (err) {
      console.error("Image processing error:", err.message)
    } finally {
      clearBusy()
    }
  }

  const handleCameraError = (error) => {
    console.error('Camera error:', error)
    setCameraError(error)
  }

  const handleImageUploadForCapture = async (event) => {
   const input = event.target
    try {
      const file = input.files[0]
      if (!file) return

    if (!selectedWorkflow) {
      errorToast({ message: t('smartCatalog.workflow'), title: t('toast.error') })
      return
    }

    if (assetType === "Multiple Folders") {
      if (!arrRefs[SELECT_ASSET_SECQUENCE]?.current?.getValue()) {
        errorToast({ message: t('smartCatalog.assetSequenceRequired'), title: t('toast.error') })
        return
      }
    }

    const fileType = file.type.toLowerCase()
    const fileName = file.name.toLowerCase()
    if (!fileName.endsWith('.jpg') && !fileName.endsWith('.jpeg') && !fileName.endsWith('.png') && 
        fileType !== 'image/jpeg' && fileType !== 'image/png') {
      errorToast({ message: t('smartCatalog.invalidImageFormat'), title: t('toast.error') })
      return
    }

    const maxSizeInBytes = 10 * 1024 * 1024
    if (file.size > maxSizeInBytes) {
      errorToast({ message: t('demo.fileSizeExceeded', { noOfMb: 10 }), title: t('toast.error') })
      return
    }

    try {
      setBusy()
      
      const reader = new FileReader()
      reader.onload = async (e) => {
        const dataUri = e.target.result
        const originalFile = dataURLtoFile(dataUri, file.name)
        const resizedBase64 = await resizeImage(originalFile)
        setImageSrc2(resizedBase64)
        setPreviewImage(true)
        setIsSequence(false)
        clearBusy()
      }
      reader.onerror = () => {
        errorToast({ message: t('error.imageUploadFail'), title: t('toast.error') })
        clearBusy()
      }
      reader.readAsDataURL(file)
    } catch (err) {
      console.error("Image upload error:", err.message)
      errorToast({ message: t('error.imageUploadFail'), title: t('toast.error') })
      clearBusy()
    }
    } finally {
      if (input) input.value = ''
    }
  }

  const rotateImage = () => {
    const imageElement = cropperRef?.current
    const cropper = imageElement?.cropper
    cropper.rotate(90)
  }

  const retakeImage = () => {
    setPreviewImage(false)
  }
  const handleSequenceImg = (e) => {
    if (e) {
      setSequences(e)
      setIsImg(true)
    } else {
      setIsImg(false)
    }
  }

  const onWorkflowChange = (e) => {
    setSelectedWorkflow(e)
    setReqData({ ...reqData, dataLocation: e })
  }

  const resetData = (resetLevel) => {
    let customFields = []
    if (resetLevel === 'Activity') {
      setSelectedWorkflow(null)
      setIsValidBoxId(false)
      setPreviewImage(false)
      setDropFirstLetterSkpBox(false)
      arrRefs[BOX_ID]?.current?.setValue('')
      arrRefs[BOX_ID]?.current?.focus()
      setState({
        activityData: {},
        showRequestInfo: false, accountLevel1: '', accountLevel2: '', accountLevel3: '', disableCheckbox: false, selectedRequest: '', selectedReqFields: [], selectAssetType: [], newTemplateSelected: false, customFields: [], templateFields: [], selectedReqFields: [], showMultipleRequestsForm: false, activityId: '', templateFieldsLocked: [], lockedTemplateFields: [], unlockedTemplateFields: [], imageExceptionNote: false, boxExceptionNote: false, isSingleRequest: false, rejectedReqsDocs: {}, isRejectedImage: false, rejectedImages: [], isRetakeImage: false, retakeImages: [], selectedRejectImageDocs: {}, selectedRetakeImageDocs: {}, selectedRejectImage: {}, selectedRetakeImage: {}, isRejectedImageModal: false, isRetakeImageModal: false
      })
    } else if (resetLevel === 'Images') {
      // arrRefs[SELECT_ASSET_TYPE].current.setValue(getState()?.activityData?.assetType)
      Object.keys(getState().activityData.template).forEach(function (key) {
        customFields.push(key)
      })

      setState({
        newTemplateId: getState().activityData.requestId,
        // templateFields: getState().activityData.template,
        // templateFieldsLocked: getState().activityData.templateLocked,
        customFields: customFields,
        // unlockedTemplateFields: [],
        // lockedTemplateFields: [],
        imageExceptionNote: false,
        selectedRejectImage: {},
        selectedRetakeImage: {}
      })
    }

    setImgDocCount(imgDocCount + 1)
    setImageCount(0)
    setState({
      imagePaths: [],
      imageNUID: [],
      showModal: false,
      // selectedTemplate: false,
    })
  }

  let fields = []
  let fieldsCustom = []
  const assetType = getState()?.activityData?.assetType
  const acc1 = getState()?.activityData?.custId
  const acc2 = getState()?.activityData?.divisionId
  const acc3 = getState()?.activityData?.departmentId
  fields.push(assetType, acc1, acc2, acc3)
  const assetType1 = { assetType: getState()?.activityData?.assetType }
  const acc11 = { acc1: getState()?.activityData?.custId }
  const acc22 = { acc2: getState()?.activityData?.divisionId }
  const acc33 = { acc3: getState()?.activityData?.departmentId }
  fieldsCustom.push(assetType1, acc11, acc22, acc33)

  const onTemplateSelection1 = async () => {
    if (getState().newTemplateId) {
      if (getState().newTemplateId !== getState()?.selectedRequest) {
        const requestData = await localGdeTransactionLite.getTemplateById(getState().newTemplateId)
        let customFields = []
        Object.keys(requestData?.template).forEach(function (key) {
          customFields.push(key)
        })

        setState({
          customFields: customFields,
          templateFields: requestData?.template,
          templateFieldsLocked: requestData?.templateLocked,
          selectedReqFields: customFields,
          newTemplateSelected: true,
          unlockedTemplateFields: [],
          lockedTemplateFields: [],
        })
      }
      successToast({ message: t('toast.templateChangedSucessfully'), title: t('toast.success') }, 5)
      closeGeneralDialog()
    } else {
      closeGeneralDialog()
    }
  }
  const onTemplateandrefSelection1 = async () => {
    if (getState().newTemplateId) {
      if (getState().newTemplateId !== getState()?.selectedRequest) {
        const requestData = await localGdeTransactionLite.getTemplateById(getState().newTemplateId)
        let customFields = []
        
        // Don't load image here - let it load lazily in the dialog
        // const natsImg = await natsService.getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, requestData.imgReference)
        // const natsImg = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, requestData.imgReference)
        // if (natsImg) {
        //   requestData.imgReference = natsImg
        // }
        
        Object.keys(requestData?.template).forEach(function (key) {
          customFields.push(key)
        })
  
        setState({
          customFields: customFields,
          templateFields: requestData?.template,
          templateFieldsLocked: requestData?.templateLocked,
          selectedReqFields: customFields,
          newTemplateSelected: true,
          unlockedTemplateFields: [],
          lockedTemplateFields: [],
        })
        requestData.boxId = selectedSkpBoxnum
        openUpdateRefImageDialog(requestData, 'templateAndRef')
      }
    } else {
      closeGeneralDialog()
    }
  }

  const onCancel = () => {
    closeGeneralDialog()
  }
  const showRequestList = async () => {
    openGeneralDialog({
      title: t('smartCatalog.templates'),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <ContentForDialogBox sortMsg={sortMsg} />,
      buttons: <ButtonsForTemplateAssign closeTemplateDialog={closeTemplateDialog} arrRefs={arrRefs} onNewTemplateSelection={getState()?.showMultipleRequestsForm ? onTemplateSelection1 : onTemplateSelection} />,
      closeX: true
    })
    setError('')
  }
  const showRequestList1 = async () => {
    openGeneralDialog({
      title: t('smartCatalog.templates'),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <ContentForDialogBox sortMsg={sortMsg} />,
      buttons: <ButtonsForTemplateAssign closeTemplateDialog={closeTemplateDialog} arrRefs={arrRefs} onNewTemplateSelection={getState()?.showMultipleRequestsForm ? onTemplateandrefSelection1 : onTemplateandrefSelection} />,
      closeX: true
    })
    setError('')
  }

  document.onkeydown = function (evt) {
    if (pathParams[2] === routePaths.activityAddImages.slice(1) && isValidBoxId && !getState()?.showModal && !visibleImage
      && !isSelectChangeMenuOpen && !isSelectChangeActionPending && !generalDialog?.isOpen) {
      if (evt.keyCode === 73 && evt.ctrlKey && prevCropDone.current) {
        if (!previewImage) {
          try {
            const captureImage = document.getElementById('outer-circle')
            var evt = new MouseEvent("click", {
              view: window,
              bubbles: true,
              cancelable: true,
              clientX: 20,
            })
            captureImage.dispatchEvent(evt)
          } catch (error) {
            console.log(error)
          }
        } else {
          if (prevCropDone.current) {
            prevCropDone.current = false
            // cropImage()
            cropImageForNats()
          }
        }
      } else if (evt.keyCode === 66 && evt.ctrlKey && imageCount > 0 && prevCropDone.current && !previewImage) {
        submitImages()
      }
    }
  }

  const onRequestSelection = async () => {
    const boxData = await localGdeTransactionLite.getBoxById(arrRefs[BOX_ID].current.getValue())
    let isReject = false
    let isRetakeImg = false
    let requests = getState()?.rejectedReqsDocs.concat(getState()?.requestDocs)
    if (!getState()?.selectedRequest) {
      return closeGeneralDialog()
    }
    requests.forEach((request) => {
      if (request?.requestId === getState()?.selectedRequest && request?.isIdpFail) {
        isReject = true
      } else if (request?.requestId === getState()?.selectedRequest && request?.isRetake) {
        isRetakeImg = true
      }
    })
    if (getState()?.isRejectedImageModal && Object.keys(getState()?.selectedRejectImage).length === 0) {
      return errorToast({ message: t('toast.selectImage'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
    } else if (getState()?.isRetakeImageModal && Object.keys(getState()?.selectedRetakeImage).length === 0) {
      return errorToast({ message: t('toast.selectImage'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
    }
    if (isReject && !getState()?.isRejectedImage) {
      boxData.forEach((doc) => {
        if (doc?.data()?.requestId === getState()?.selectedRequest) {
          setState({ activityId: doc?.id })
        }
      })
      return showRejectedImgsModal()
    } else if (isRetakeImg && !getState()?.isRetakeImage) {
      boxData.forEach((doc) => {
        if (doc?.data()?.requestId === getState()?.selectedRequest) {
          setState({ activityId: doc?.id })
        }
      })
      return showRetakeImgsModal()
    }
    setBusy()
    // getState()?.requests.forEach((singleRequest) => {
    //   if (singleRequest.requestId === request['requestId']) {
    //     singleRequest.isChecked = !singleRequest.isChecked
    //   } else {
    //     singleRequest.isChecked = false
    //   }
    // })
    // const isCheckedFalse = (val) => val.isChecked === false
    // if (getState()?.requests.every(isCheckedFalse)) {
    //   setIsValidBoxId(false)
    //   setState({
    //     showRequestInfo: false
    //   })
    // } else {
    setIsValidBoxId(true)
    let docId
    let templateFields
    let templateFieldsLocked
    let assestType
    const [lineOfBusiness, assetType, , templateType] = await localGdeTransactions.getGdeConfig()
    boxData.forEach((doc) => {

      if (doc?.data()?.requestId === getState()?.selectedRequest) {
        docId = doc.id
        templateFields = doc?.data()?.template,
          templateFieldsLocked = doc?.data()?.templateLocked,
          assestType = doc?.data()?.assetType
      }
    })
    let accountLevel1
    let accountLevel2
    let accountLevel3
    let requestFields = []
    const selectAssetTypes = []
    requests.forEach((req) => {
      if (req?.requestId === getState()?.selectedRequest) {
        accountLevel1 = req?.accountLevel1
        accountLevel2 = req?.accountLevel2
        accountLevel3 = req?.accountLevel3
        requestFields.push(getState()?.selectedRequest)
        let requestParentAssetType = false
        Object.values(assetType).forEach((assetTypeEach) => {
          if (assetTypeEach?.subAssetTypes) {
            Object.values(assetTypeEach?.subAssetTypes).forEach((subAssetTypeEach) => {
              if (subAssetTypeEach.name === req.assetType && !requestParentAssetType) {
                requestParentAssetType = assetTypeEach.name
              }
            })
          }
        })
        Object.values(assetType).forEach((assetTypeEach) => {
          if (assetTypeEach?.subAssetTypes && assetTypeEach.name === requestParentAssetType) {
            Object.values(assetTypeEach?.subAssetTypes).forEach((subAssetTypeEach) => {
              if (subAssetTypeEach?.isActive) {
                selectAssetTypes.push({ value: subAssetTypeEach.name, label: subAssetTypeEach.name })
              }
            })
          }
        })
        setState({ activityData: req })
      }
    })
    setNewAssetType(assestType)
    setState({ showRequestInfo: true, accountLevel1: accountLevel1, accountLevel2: accountLevel2, accountLevel3: accountLevel3, disableCheckbox: true, templateFields: getState()?.isRejectedImage ? getState()?.selectedRejectImage?.templateFields : templateFields, templateFieldsLocked: getState()?.isRejectedImage ? getState()?.selectedRejectImage?.templateLocked : templateFieldsLocked, selectedReqFields: requestFields, selectAssetType: selectAssetTypes, activityId: docId, newTemplateSelected: false, unlockedTemplateFields: [], lockedTemplateFields: [], })
    const getBoxImages = await localGdeTransactionLite.getImages(getState().activityId, getState()?.activityData?.skpBoxNbr)

    if (getBoxImages.size > 0) {
      setImgDocCount(getBoxImages.size)
    }
    // if (assestType) {
    //   setTimeout(() => {
    //     arrRefs[SELECT_ASSET_TYPE].current.setValue(assestType)
    //   }, 1000)
    // }
    // }
    closeGeneralDialog()
    clearBusy()
    let templateData = await localGdeTransactions.getTemplateById_SC(getState()?.activityData?.templateId)
    templateData = templateData.data()
    const { accountLevel1: l1, accountLevel2: l2, accountLevel3: l3 } = templateData
    setSelectLvls({ accountLevel1: l1, accountLevel2: l2, accountLevel3: l3 })
  }

  const handleLockableFields = async (data) => {
    const lockedTemplateFields = {}
    const unlockedTemplateFields = {}
    Object.keys(getState()?.templateFields).forEach((key) => {
      if (!data[key]) {
        const fieldData = {
          ...getState().templateFields[key]
        }
        fieldData.isLocked = false
        fieldData.lockedValue = ''
        unlockedTemplateFields[key] = fieldData
      } else {
        const fieldData = {
          ...getState().templateFields[key]
        }
        fieldData.isLocked = true
        fieldData.lockedValue = data[key]
        lockedTemplateFields[key] = fieldData
      }
    })

    if (getState()?.templateFieldsLocked) {
      Object.keys(getState()?.templateFieldsLocked).forEach((key) => {
        if (data[key]) {
          const fieldData = {
            ...getState().templateFieldsLocked[key]
          }
          fieldData.isLocked = true
          fieldData.lockedValue = data[key]
          lockedTemplateFields[key] = fieldData
        }
      })
    }


    setState({
      lockedTemplateFields: lockedTemplateFields,
      unlockedTemplateFields: unlockedTemplateFields,
    })
  }

  const exceptionOptions = [
    { value: 'Image Exception', label: t('smartCatalog.imgException'), style: { color: theme.palette.primary.main } },
    { value: 'Box Exception', label: t('smartCatalog.boxException'), style: { color: theme.palette.primary.main } },
  ]
  const [size, setSize] = useState({ width: '100%', height: 'auto', minWidth: '545px', minHeight: '450px' })

  const handleResize = (e) => {
    const newWidth = e.clientX - e.target.offsetLeft
    const newHeight = e.clientY - e.target.offsetTop

    setSize({ width: newWidth, height: newHeight })
  }
  const onExceptionSelection = async (value) => {
    setState({
      showExceptionModal: true,
      showExceptionModalFor: value,
    })
  }
  const showLargeImage = (image) => {
    setVisibleImage(image)
  }

  const hideLargeImage = () => {
    setVisibleImage(null)
  }
  const setError = (value) => {
    setState({ error: value })
  }

  const handleImageUpload = async (value) => {
    if (value) {
      setBusy()
      const imageRef = storageRef(
        storage,
        `smartCatalog/gde_refImg_${workerId}_${Date.now()}.jpg`
      )
      uploadBytes(imageRef, value)
        .then((snapshot) => {
          getDownloadURL(snapshot.ref)
            .then((url) => {
              const gspath = `gs://${snapshot.ref.bucket}/${snapshot.ref.fullPath}`
              setSelectedRefImage(url)
              setState({
                selectedRefImageGsPath: gspath,
              })
              setError('')
              clearBusy()
            })
            .catch((error) => {
              console.log(error.message)
              setError(t('error.imageUploadFail'))
              clearBusy()
            })
        })
        .catch((error) => {
          console.log(error.message)
          setError(t('error.imageUploadFail'))
          clearBusy()
        })
    }
  }
  const handleImageUploadToNats = async (originalFile) => {
    if (originalFile) {
      const rename = `nats_assetImg_${workerId}_${Date.now()}.jpg`
      const renamedFile = new File([originalFile], rename, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      })
      try {
        const { nuid, name } = await natsService.uploadRefImg(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, renamedFile)
        
        // Ensure we set a valid string value, not false or empty
        if (name && name !== '') {
          setSelectedRefImage(name)
          setState({
            selectedRefImageGsPath: nuid,
          })
          
          // Load the image URL for preview
          // const tmpUrl = await natsService.getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, name)
          const tmpUrl = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, name)
          if (tmpUrl) {
            setSelectedNatsRefImage(tmpUrl)
            setLoadedRefImageUrl(tmpUrl)
          }
        } else {
          throw new Error('Failed to get image reference from NATS')
        }
      } catch (error) {
        console.error('Error uploading reference image to NATS:', error)
        const errorState = getState().validationErrors || {}
        setState({ 
          validationErrors: { 
            ...errorState, 
            btnError: 'Failed to upload reference image. Please try again.' 
          } 
        })
      }
    } else {
      const error = getState().validationErrors
      setState({ validationErrors: { ...error, btnError: 'Incorrect format or size.' } })
    }
  }

  const isRejectedImageModal = getState().isRejectedImageModal
  const isRetakeImg = getState().isRetakeImage
  const isDisabled = isRejectedImageModal || isRetakeImg

  const validateRefImage = (file) => {
    const maxSizeInBytes = 5 * 1024 * 1024 // coverting file size in bytes
    const isFileSizeExceeded = doesFileSizeExceed(file.size, maxSizeInBytes)
    const fileType = file.type.toLowerCase()
    const fileName = file.name.toLowerCase()
    if (!fileName.endsWith('.jpg') && !fileName.endsWith('.jpeg') && fileType !== 'image/jpeg' && isFileSizeExceeded) {
      setError(t('demo.uploadJpgTypeandSizeErr', { noOfMb: '5' }))
      return false
    } else if (!fileName.endsWith('.jpg') && !fileName.endsWith('.jpeg') && fileType !== 'image/jpeg') {
      setError(t('demo.uploadJpgType'))
      return false
    } else if (isFileSizeExceeded) {
      setError(t('demo.fileSizeExceeded', { noOfMb: 5 }))
      return false
    } else {
      return true
    }
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0]
    // setSelectedImage(file)
    // setSelectedImageLabel(file.name)
    if (file.length !== 0 && validateRefImage(file)) {
      handleImageUpload(file)
      setError('')
      clearFormStatus()
      getState().error === '' && file && successToast({ message: t('toast.RefImgChangedSucessfully'), title: t('toast.success') }, 5)
    } else {
      return null
    }
  }

  const selectChange = async (value) => {
    const isChangeDropdownAction = value === 'refImageChange' || value === 'templateChange' || value === 'templateAndrefImgChange'
    if (isChangeDropdownAction) {
      setIsSelectChangeActionPending(true)
    }
    try {
      if (value === 'refImageChange') {
        // fileInputRef.current.click()
        const reqId = getState().newTemplateId ? getState().newTemplateId : getState()?.selectedRequest
        const requestData = await localGdeTransactionLite.getRequestById(reqId)
        requestData.boxId = selectedSkpBoxnum
        // Don't load image here - open dialog immediately and load image lazily inside
        // const natsImg = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, requestData.imgReference)
        // const natsImg = await natsService.getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, requestData.imgReference)
        // const natsImg = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, requestData.imgReference)
        // if (natsImg) {
        //   requestData.imgReference = natsImg
        // }
        openUpdateRefImageDialog(requestData)
        arrRefs[SELECT_CHANGE].current.clear()
      } else if (value === 'templateChange') {
        await showRequestList()
        arrRefs[SELECT_CHANGE].current.clear()
      } else if (value === 'templateAndrefImgChange') {
        await showRequestList1()
        arrRefs[SELECT_CHANGE].current.clear()
      }
    } finally {
      if (isChangeDropdownAction) {
        setIsSelectChangeActionPending(false)
      }
    }
  }

  selectAssetSequence.forEach((element, index) => {
    if (element.label !== '--Select--') {
      element.label = t(`dropdowns.${element.value}`)
    }
  })
  return (
    <>{!showBanner
      ? <MainRouteSubRoutePage
        mainTitle='routeTitles.smartCatalogManagement'
        subTitle='routeTitles.requestImageLocalCapture'
        createPage={true}
        style={{ overflowX: 'auto' }}
      >
        <Grid container spacing={2}>
          <Grid item xs={11} sm={11} md={11} style={{ minHeight: '3.5vw' }}>
          </Grid>
          <Grid item xs={1} sm={1} md={1} style={{ minHeight: '3vw' }}>
            <div style={{ float: 'right' }}>
              {isValidBoxId ? (<MenuButton
                id={'allJobs_ellipsis'}
                buttonIcon={<MoreVert />}
                // rowdata={rowData}
                items={exceptionOptions}
                onSelect={(value) => { onExceptionSelection(value) }}
              />) : null}
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <Card style={{ minHeight: '6vw', margin: '0.5rem' }}>
              <CardContent style={{ margin: '0.5rem' }}>
                <CreateTemplateIntentContainer>
                  <TextField
                    id={'createActivity_accountLevel'}
                    data={data}
                    fieldTemplate={formTemplate[BOX_ID]}
                    ref={arrRefs[BOX_ID]}
                    onKeyUp={(e) => validateSkpBoxId(e)}
                    disabled={isValidBoxId}
                    inputProps={{ maxLength: 50 }}
                    onInput={(e) => convertToUpperCase(e)}
                    InputProps={{ style: { width: '160px' } }}
                  />
                  {isValidBoxId && <><OutlinedButton style={{ width: 'fit-content', minWidth: '80px', height: '36.5px', margin: '2px', padding: '6px 12px', whiteSpace: 'nowrap' }} onClick={() => resetData('Activity')}>buttons.Reset</OutlinedButton>
                    <div style={{ textAlign: 'center', width: '100%', maxWidth: '100%', minWidth: '150px' }}>
                      <Select
                        items={changelist}
                        fieldTemplate={formTemplate[SELECT_CHANGE]}
                        ref={arrRefs[SELECT_CHANGE]}
                        onChange={selectChange}
                        onOpen={() => setIsSelectChangeMenuOpen(true)}
                        onClose={() => setIsSelectChangeMenuOpen(false)}
                        noTranslateItems
                        noTranslate={true}
                      />
                      <VisuallyHiddenInput
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        ref={fileInputRef}
                      />
                      {getState().error && <ErrorLabel>{getState().error}</ErrorLabel>}
                      {/* <InputFileUpload
                    onImageCapture={handleImageUpload}
                    error={getState().error}
                    setError={setError} />  */}
                      {isLoadingRefImage
                        ? <div
                          ref={imageRef}
                          style={{
                            height: '70px',
                            width: '100px',
                            marginTop: '5px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#f0f0f0',
                            border: '1px solid #ddd'
                          }}
                        >
                          <CircularProgress size={20} />
                        </div>
                        : loadedRefImageUrl
                          ? <img
                            ref={imageRef}
                            src={loadedRefImageUrl}
                            alt="thumbnail"
                            style={{ height: '70px', width: "100px", cursor: 'pointer', marginTop: '5px', objectFit: 'contain' }}
                            onClick={() => showLargeImage(loadedRefImageUrl)}
                            onError={() => {
                              console.error('Failed to load image:', loadedRefImageUrl)
                              setLoadedRefImageUrl(null)
                            }}
                          />
                          : <div
                            ref={imageRef}
                            style={{
                              height: '70px',
                              width: '100px',
                              marginTop: '5px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: '#f0f0f0',
                              border: '1px solid #ddd',
                              color: '#999',
                              fontSize: '10px',
                              textAlign: 'center'
                            }}
                          >
                            {t('smartCatalog.imageNotAvailable')}
                          </div>
                      }
                    </div>
                    {visibleImage && (
                      <Draggable cancel=".resize-handle">
                        <div className={classes.floatingimagecontainer} style={{
                          width: `${size.width}px`,
                          height: `${size.height}px`,
                          position: "absolute",
                          transition: 'width 0.2s, height 0.2s',
                          overflow: "hidden",
                          cursor: "grab",
                        }}>
                          <div>
                            <InputFileUploadButton
                              onImageCapture={handleImageUploadToNats}
                              setCameraRef={setCameraRef}
                              error={getState().error}
                              setError={setError}
                              maxSize={5}
                              allowedFormats={['JPG', 'JPEG']}
                              changeRefText={true}
                            />
                            <span
                              className="close-icon"
                              style={{
                                position: "absolute",
                                top: "0px", // Adjust top margin as needed
                                right: "1px", // Adjust right margin as needed
                                fontSize: "18px", // Icon size
                                // color: "red", // Icon color
                                cursor: "pointer", // Pointer cursor for interaction
                                // zIndex: 10, // Make sure it appears on top
                              }}
                              onClick={hideLargeImage} // Call the hide function on click
                            >
                              <CloseIcon />
                            </span>
                          </div>
                          <img
                            src={loadedRefImageUrl || selectedNatsRefImage || getState().activityData.imgReference}
                            alt="Large view"
                            className={classes.floatingLargeImage}
                            onError={() => {
                              console.error('Failed to load large image')
                            }}
                          />
                          <div
                            className="resize-handle"
                            style={{
                              position: "absolute",
                              bottom: 0,
                              right: 0,
                              width: "10px",
                              height: "10px",
                              backgroundImage:
                                "linear-gradient(to right, transparent 50%, black 50%), linear-gradient(to bottom, transparent 50%, black 50%)",
                              backgroundSize: "100% 2px, 2px 100%",
                              cursor: "nwse-resize", // Set resize cursor for the handle
                            }}
                            // onMouseDown={(e) => { e.preventDefault()  
                            //   window.addEventListener("mousemove", handleResize)  
                            //   window.addEventListener("mouseup", () => { 
                            //   window.removeEventListener("mousemove", handleResize) 
                            //   })  
                            //   }}

                            onMouseDown={(e) => {
                              e.preventDefault()

                              // Start Resizing
                              const container = e.target.offsetParent  // Reference to the container
                              const startX = e.clientX
                              const startY = e.clientY
                              const startWidth = container.offsetWidth
                              const startHeight = container.offsetHeight

                              const handleResize = (resizeEvent) => {
                                const newWidth = Math.max(startWidth + (resizeEvent.clientX - startX), 70)  // Limit minimum width
                                const newHeight = Math.max(startHeight + (resizeEvent.clientY - startY), 60)  // Limit minimum height

                                container.style.width = `${Math.min(newWidth, 700)}px`  // Limit maximum width
                                container.style.height = `${Math.min(newHeight, 600)}px`  // Limit maximum height
                              }

                              const stopResize = () => {
                                window.removeEventListener("mousemove", handleResize)
                                window.removeEventListener("mouseup", stopResize)
                              }

                              window.addEventListener("mousemove", handleResize)
                              window.addEventListener("mouseup", stopResize)
                            }}
                          ></div>
                        </div>
                      </Draggable>
                    )}
                  </>}
                </CreateTemplateIntentContainer>
                <Typography paragraph={true} style={{ fontSize: '16px', color: '#FFF', backgroundColor: '#db4437', width: 'fit-content' }}>{getState()?.errorMsg}</Typography>
              </CardContent>
            </Card>
            {getState()?.showMultipleRequestsForm && getState()?.requests.length && 1 == 2 &&
              <>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ width: '50px' }}></TableCell> {/* Adjust width as needed */}
                        <TableCell>{`${t('smartCatalog.requestIds')}`}</TableCell>
                        <TableCell colSpan={getState()?.requests[0]?.requestFields?.length || 1}>{`${t('smartCatalog.fields')}`}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {getState()?.requests?.map((field) => {
                        return (
                          <TableRow key={field.requestId}>
                            <TableCell>
                              <Checkbox checked={field.isChecked} onChange={() => onRequestSelection(field)} />
                            </TableCell>
                            <TableCell>{field?.requestId}</TableCell>
                            {field?.requestFields?.map((field1, index) => (
                              <TableCell key={index}>{field1}</TableCell>
                            ))}
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>

            }
            {isValidBoxId && getState()?.showRequestInfo &&
              <>
                <Card style={{ margin: '0.5rem', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: '100%', overflow: 'visible', minWidth: 0, alignItems: 'flex-start', gap: '0.5rem' }}>
                  {fields.length !== 0 && <Container id={'imageCapture_assetType'} style={{ margin: '0.25rem', minWidth: '180px', flex: '0 0 auto', overflow: 'visible', maxWidth: '240px' }} className={classes.container}>
                    <GroupedMenu
                      id={'createActivity_workFlow'}
                      assetTypes={workflow}
                      label={t('templates.workflow')}
                      onSelect={onWorkflowChange}
                      selected={selectedWorkflow}
                      size={190}
                    />
                    <Typography variant="body1" className={classes.content}>
                      <span className={classes.value}>{`${t('templates.assetType')}`}:</span> <span className={classes.value}>{assetType}</span>
                    </Typography>
                    {/* <Select
              id={'imageCapture_assetType'}
              items={}
              fieldTemplate={formTemplate[SELECT_ASSET_TYPE]}
              ref={arrRefs[SELECT_ASSET_TYPE]}
              noTranslateItems
              onChange={(e) => setNewAssetType(e)}
              style={{ marginBottom: '1rem', marginTop: '1rem' }}
            /> */}
                    {assetType === 'Multiple Folders' &&
                      <Select
                        id={'imageCapture_assetType'}
                        items={selectAssetSequence}
                        fieldTemplate={formTemplate[SELECT_ASSET_SECQUENCE]}
                        ref={arrRefs[SELECT_ASSET_SECQUENCE]}
                        noTranslateItems
                        onChange={(e) => handleSequenceImg(e)}
                      />}
                    <Typography variant="body1" className={classes.content}>
                      <span className={classes.value}>{`${t('templates.accountLeveOne')}`}:</span> <span className={classes.value}>{acc1}</span>
                    </Typography>
                    <Typography variant="body1" className={classes.content}>
                      <span className={classes.value}>{`${t('templates.accountLeveTwo')}`}:</span> <span className={classes.value}>{acc2}</span>
                    </Typography>
                    <Typography variant="body1" className={classes.content}>
                      <span className={classes.value}>{`${t('templates.accountLeveThree')}`}:</span> <span className={classes.value}>{acc3}</span>
                    </Typography>
                  </Container>}

                  {getState().selectedReqFields.length > 0 && <Container style={{ margin: '0.25rem', minWidth: '180px', flex: '0 1 auto', overflow: 'visible', maxWidth: '240px' }} id={'templateFields'} className={classes.container}>
                    {/* <Link component='button' onClick={() => showRequestList()} style={{ fontSize: '13px', textDecoration: 'none', fontWeight: 'bold' }}>{t('buttons.changeTemplate')}</Link> */}
                    {/* <Link component='button' onClick={() => showRequestList1()}  style={{ fontSize: '13px', letterSpacing:'-0.2px', textDecoration: 'none', fontWeight: 'bold', margin: '10px 0 10px'}}>{t('Search.ChangeTemplateAndRefImage')}</Link> */}
                    <div style={{ paddingLeft: '0px', marginBottom: '4px' }}>
                      <Typography variant="body1" className={classes.content} style={{ marginBottom: '4px', lineHeight: '1.2' }}>
                        <span >{`${t('tableColumns.lockedFields')}`} </span>
                      </Typography>
                    </div>
                    <LockableFieldsWrapper>
                      <LockableFields
                        templateFields={getState().templateFields}
                        templateFieldsLocked={getState().templateFieldsLocked}
                        lockedTemplateFields={getState().lockedTemplateFields}
                        unlockedTemplateFields={getState().unlockedTemplateFields}
                        getLockableFields={handleLockableFields}
                        accountLevel1={getState().accountLevel1}
                      />
                    </LockableFieldsWrapper>
                  </Container>}
                </Card>
              </>

            }
            {isValidBoxId && !getState()?.showMultipleRequestsForm &&
              <>
                <Card style={{ width: '100%', margin: '0.5rem', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', overflow: 'visible', minWidth: 0, alignItems: 'flex-start', gap: '0.5rem' }}>
                  {fields.length !== 0 && <Container id={'imageCapture_assetType'} style={{ margin: '0.5rem', minWidth: '200px', flex: '0 0 auto', overflow: 'visible', maxWidth: '200px' }} className={classes.container}>
                    <GroupedMenu
                      id={'createActivity_workFlow'}
                      assetTypes={workflow}
                      label={t('templates.workflow')}
                      onSelect={onWorkflowChange}
                      selected={selectedWorkflow}
                      size={190}
                    />
                    <Typography variant="body1" className={classes.content}>
                      <span className={classes.value}>{`${t('templates.assetType')}`}:</span> <span className={classes.value}>{assetType}</span>
                    </Typography>
                    {/* <Select
              id={'imageCapture_assetType'}
              items={}
              fieldTemplate={formTemplate[SELECT_ASSET_TYPE]}
              ref={arrRefs[SELECT_ASSET_TYPE]}
              noTranslateItems
              onChange={(e) => setNewAssetType(e)}
              style={{ marginBottom: '1rem', marginTop: '1rem' }}
            /> */}
                    {assetType === 'Multiple Folders' &&
                      <Select
                        id={'imageCapture_assetType'}
                        items={selectAssetSequence}
                        fieldTemplate={formTemplate[SELECT_ASSET_SECQUENCE]}
                        ref={arrRefs[SELECT_ASSET_SECQUENCE]}
                        noTranslateItems
                        onChange={(e) => handleSequenceImg(e)}
                      />}
                    <Typography variant="body1" className={classes.content}>
                      <span className={classes.value}>{`${t('templates.accountLeveOne')}`}:</span> <span className={classes.value}>{acc1}</span>
                    </Typography>
                    <Typography variant="body1" className={classes.content}>
                      <span className={classes.value}>{`${t('templates.accountLeveTwo')}`}:</span> <span className={classes.value}>{acc2}</span>
                    </Typography>
                    <Typography variant="body1" className={classes.content}>
                      <span className={classes.value}>{`${t('templates.accountLeveThree')}`}:</span> <span className={classes.value}>{acc3}</span>
                    </Typography>
                  </Container>}
                  {getState().customFields.length > 0 && <Container style={{ margin: '0.5rem', minWidth: '150px', flex: '0 1 auto', overflow: 'visible', maxWidth: '240px' }} id={'templateFields'} className={classes.container}>
                    {/* <Link component='button' onClick={() => showRequestList()} style={{ fontSize: '13px', textDecoration: 'none', fontWeight: 'bold' }}>{t('buttons.changeTemplate')}</Link> */}
                    {/* <Link component='button' onClick={() => showRequestList1()}  style={{ fontSize: '13px', letterSpacing:'-0.2px', textDecoration: 'none', fontWeight: 'bold', margin: '10px 0 10px'}}>{t('Search.ChangeTemplateAndRefImage')}</Link> */}
                    <div style={{ paddingLeft: '0px', marginBottom: '4px' }}>
                      <Typography variant="body1" className={classes.content} style={{ marginBottom: '4px', lineHeight: '1.2' }}>
                        <span >{`${t('tableColumns.lockedFields')}`} </span>
                      </Typography>
                    </div>
                    <LockableFields
                      templateFields={getState().templateFields}
                      templateFieldsLocked={getState().templateFieldsLocked}
                      lockedTemplateFields={getState().lockedTemplateFields}
                      unlockedTemplateFields={getState().unlockedTemplateFields}
                      getLockableFields={handleLockableFields}
                      accountLevel1={getState().accountLevel1}
                    />
                  </Container>}
                </Card>
              </>}
            <Grid item xs={12}>
              {isImg && isValidBoxId && sequences === "Left to Right" &&
                <img src={stackedLR} style={{width: 'auto', maxWidth: 'min(560px, 85vw)', maxHeight: '260px', height: 'auto', objectFit: 'contain', display: 'block', margin: 'auto 0', }} alt="" />
              }
              {isImg && isValidBoxId && sequences === "Top to Bottom" &&
                <img src={stackedTB} style={{width: '100%', maxWidth: '180px', maxHeight: '120px', height: 'auto', objectFit: 'contain', display: 'block', margin: 'auto 0', }} alt="" />
              }
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            {isValidBoxId &&
              <Box component={'div'} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', maxWidth: '100%', height: 'auto', minHeight: '350px', padding: '0.5rem' }}>
                {!previewImage && imageCount < appConstants.totalImagesAllowedToCapture &&
                  <div style={{
                    width: '500px',
                    // maxWidth: '100%',
                    height: '350px',
                    // minHeight: '350px',
                    resize: 'both',
                    overflow: 'hidden',
                    position: 'relative'
                  }}>
                    {cameraError && isSandbox 
                    ? <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '350px',
                        backgroundColor: '#f5f5f5',
                        border: '2px dashed #ccc',
                        borderRadius: '8px',
                        padding: '20px',
                        textAlign: 'center'
                      }}>
                        <Typography variant="h6" style={{ color: '#666', marginBottom: '16px' }}>
                          {t('smartCatalog.cameraNotAvailable')}
                        </Typography>
                        <Typography variant="body2" style={{ color: '#888', marginBottom: '24px', maxWidth: '400px' }}>
                          {t('smartCatalog.cameraNotAvailableDescription')}
                        </Typography>
                        <input
                          type="file"
                          accept="image/jpeg,image/png,image/jpg"
                          onChange={handleImageUploadForCapture}
                          ref={uploadImageInputRef}
                          style={{ display: 'none' }}
                        />
                        <ContainedButton
                          onClick={() => uploadImageInputRef.current?.click()}
                          style={{ marginBottom: '12px' }}
                        >
                          buttons.uploadImage
                        </ContainedButton>
                        <OutlinedButton
                          onClick={() => {
                            setCameraError(null)
                            setCameraRef(prev => prev + 1)
                          }}
                          style={{ fontSize: '12px' }}
                        >
                          buttons.retryCamera
                        </OutlinedButton>
                      </div>
                    : 
                      <>
                        <Camera
                          onTakePhoto={(dataUri) => { handleTakePhoto(dataUri) }}
                          onCameraError={isSandbox ? handleCameraError : undefined}
                          isDisplayStartCameraError={!isSandbox}
                          isMaxResolution={true}
                          key={cameraRef}
                          // ref={camera}
                          sizeFactor={1}
                          imageType='jpg'
                          imageCompression={0.5}
                        />
                        {isSandbox && (
                          <div style={{
                            position: 'absolute',
                            bottom: '10px',
                            height: '103px',
                            left: '10px',
                            zIndex: 10
                          }}>
                            <input
                              type="file"
                              accept="image/jpeg,image/png,image/jpg"
                              onChange={handleImageUploadForCapture}
                              ref={uploadImageInputRef}
                              style={{ display: 'none' }}
                            />
                            <OutlinedButton
                              onClick={() => uploadImageInputRef.current?.click()}
                              style={{
                                backgroundColor: 'rgba(255,255,255,0.9)',
                                fontSize: '12px',
                                padding: '6px 12px'
                              }}
                            >
                              buttons.uploadImage
                            </OutlinedButton>
                          </div>
                        )}
                      </>
                    }
                  </div>
                }
                {imageSrc2 && previewImage &&
                  <div style={{ height: 350, width: 500 }}>
                      <Cropper
                        style={{ height: '350px', minHeight: '350px', width: '500px', maxWidth: '100%', marginBottom: '1rem' }}
                        zoomTo={0}
                        initialAspectRatio={1}
                        preview='.img-preview'
                        src={imageSrc2}
                        viewMode={1}
                        minCropBoxHeight={15}
                        minCropBoxWidth={15}
                        background={false}
                        responsive={true}
                        autoCropArea={100}
                        checkOrientation={false}
                        scalable={true}
                        zoomable={true}
                        onInitialized={(instance) => {
                          setCropper(instance)
                        }}
                        guides={true}
                        ref={cropperRef}
                      />
                  </div>
                }
              </Box>
            }
          </Grid>
        </Grid>
        <Grid container spacing={2}>

          <Grid item xs={12} sm={12} md={6}>
            {isValidBoxId && (
              <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px', flexWrap: 'wrap', gap: '10px' }}>
                <div>
                  {isValidBoxId && (
                    <ContainedButton
                      style={{ minWidth: '110px', height: '36.5px' }}
                      onClick={handleOpenDialog}
                      disabled={isDisabled}
                    >
                      buttons.closeBox
                    </ContainedButton>
                  )}
                </div>
                <Dialog open={dialogOpen} onClose={handleCloseDialog}>
                  <DialogTitle>{t('templates.ConfirmAction')}</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      {t('templates.closeBoxConfirm')}
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                      {t('dialogs.cancel')}
                    </Button>
                    <Button onClick={handleConfirmCloseBox} color="primary">
                      {t('templates.confirm')}
                    </Button>
                  </DialogActions>
                </Dialog>
                <span style={{ minWidth: '160px', height: '36.5px', padding: '6px', color: 'black', backgroundColor: '#e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '10px' }}>
                  {t('tableColumns.totalFileCount')}: {totalImageCount}
                </span>
              </div>
            )}

          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            {isValidBoxId && (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                <span style={{ minWidth: '165px', height: '36.5px', padding: '6px', color: 'lightblack', backgroundColor: '#e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '10px' }}>{t('tableColumns.imageCount')}: {imageCount} / {appConstants.totalImagesAllowedToCapture}</span>
                {isValidBoxId && !previewImage && <ContainedButton style={{ minWidth: '110px', height: '36.5px', margin: '2px' }} onClick={() => submitImages()} disabled={(imageCount === 0)}>buttons.submit</ContainedButton>}
                {
                  isValidBoxId && previewImage &&
                  <>
                    <ContainedButton style={{ minWidth: '180px', height: '36.5px', margin: '2px' }} onClick={() => cropImageForNats()} disabled={imageCount >= appConstants.totalImagesAllowedToCapture}>buttons.cropImage</ContainedButton>
                    {/* <OutlinedButton style={{ width: '80px', height: '36.5px', margin: '2px' }} onClick={() => rotateImage()}>buttons.rotateImage</OutlinedButton> */}
                    <OutlinedButton style={{ minWidth: '80px', height: '36.5px', margin: '2px', padding: '6px 12px', whiteSpace: 'nowrap' }} onClick={() => retakeImage()}>buttons.retakeImage</OutlinedButton>
                  </>}
              </div>)}
          </Grid>
          <Grid item xs={12}>
          </Grid>

        </Grid>
        {getState().showModal
          ? (
            <LocalActivitySubmitImagesModal
              showModal={getState().showModal}
              handleShowModal={handleShowModal}
              handleSubmitImages={saveImages}
              getExceptionData={getExceptionData}
              reqData={reqData}
            />
          )
          : null}
        {getState().showExceptionModal
          ? (
            <LocalActivityExceptionModal
              showModal={getState().showExceptionModal}
              showExceptionModal={showExceptionModal}
              getExceptionData={getExceptionData}
              showExceptionModalFor={getState().showExceptionModalFor}
            />
          )
          : null}
        <ImageContainer />
      </MainRouteSubRoutePage>
      : <>{showBanner === true && <RestrictImage />}</>}
    </>
  )
}

export default RequestImageCapture